const locale = {
  aWholeProductIsFinished:
    "ผลิตภัณฑ์ที่สมบูรณ์เป็นผลิตภัณฑ์สำเร็จรูปที่จำหน่ายในสถานที่ของคุณ ด้วยตัวเลือกผลิตภัณฑ์ คุณอาจเลือกที่จะจำหน่ายผลิตภัณฑ์ในรูปแบบที่ต่างกัน เช่น รสชาติ สี และขนาด ผลิตภัณฑ์ที่สมบูรณ์และตัวเลือกผลิตภัณฑ์จะมีรายการวัตถุดิบเฉพาะ",
  accessToken: "โทเค็นการเข้าถึง",
  accommodation: "ที่พัก",
  account: "บัญชี",
  accountAlreadyExists: "อีเมลนี้ได้เชื่อมโยงกับบัญชีในสถานที่นี้แล้ว",
  accountCantSeemToFind:
    "อุ้ย! ดูเหมือนเราจะไม่พบบัญชีของคุณ โปรดติดต่อผู้จัดการสถานที่เพื่อขอความช่วยเหลือ",
  accountCode: "รหัสบัญชี",
  accountCodeAddedName: "เพิ่มรหัสบัญชี “{0}“ แล้ว",
  accountCodeAlreadyExist: "มีรหัสบัญชีอยู่แล้ว",
  accountEmailAdded: "เพิ่มบัญชี “{0}“ แล้ว",
  accountEmailRemoved: "ลบบัญชี “{0}“ แล้ว",
  accountIsActive: "บัญชีใช้งานอยู่",
  accountMapping: "การทำแผนที่บัญชี",
  accountMappingDescription: "ตั้งค่าและจับคู่บัญชีของคุณกับระบบ PouchVENUE",
  accountName: "ชื่อบัญชี",
  accountNotFound: "ไม่พบบัญชี",
  accountSettings: "การตั้งค่าบัญชี",
  accountType: "ประเภทบัญชี",
  accountingSoftware: "โปรแกรมบัญชี",
  accounts: "บัญชี",
  accrNo: "บัญชี #:",
  actions: "การกระทำ",
  activateInPos: "เปิดใช้งาน ณ จุดขาย",
  activateOnPos: "เปิดใช้งาน ณ จุดขาย",
  activateVariant: "เปิดใช้งานตัวเลือก",
  active: "ใช้งาน",
  activeDateRange: "ช่วงวันที่ใช้งาน",
  actualClosingBalance: "ยอดเงินปิดตามจริง",
  actualQty: "ปริมาณจริง",
  actualStockQty: "ปริมาณสต็อคตามจริง",
  add: "เพิ่ม",
  addANote: "เพิ่มหมายเหตุ...",
  addAValidAttributeAndOptions: "เพิ่มคุณลักษณะและตัวเลือกที่ถูกต้อง",
  addAWholeProduct: "เพิ่มผลิตภัณฑ์ที่สมบูรณ์",
  addAccount: "เพิ่มบัญชี",
  addAnotherAccount: "เพิ่มบัญชีอื่น",
  addAnotherAttribute: "เพิ่มคุณลักษณะอื่น",
  addAnotherProductOrSupplyItem: "เพิ่มผลิตภัณฑ์หรือรายการวัตถุดิบอื่น",
  addAnotherSupplyItem: "เพิ่มรายการวัตถุดิบอื่น",
  addCustomQuestion: "เพิ่มคำถามที่กำหนดเอง",
  addNewAccount: "เพิ่มบัญชีใหม่",
  addNewAccountCode: "ทำสรุปประจำวัน",
  addNewAccountCodeName: 'เพิ่มรหัสบัญชีใหม่่ "{0}"',
  addNewPaymentMethod: "เพิ่มวิธีการชำระเงินใหม่",
  addNewSupplyItem: "เพิ่มรายการวัตถุดิบใหม่",
  addNewSupplyItemSelect: "เพิ่มรายการวัตถุดิบใหม่ “{0}”",
  addNewTax: "เพิ่มภาษีใหม่",
  addNote: "เพิ่มหมายเหตุ",
  addOption: "เพิ่มตัวเลือก",
  addPaymentMethod: "เพิ่มวิธีการชำระเงิน",
  addProduct: "เพิ่มผลิตภัณฑ์",
  addProducts: "เพิ่มผลิตภัณฑ์หรือรายการวัตถุดิบในชุดผลิตภัณฑ์นี้",
  addThisProduct: "เพิ่มผลิตภัณฑ์นี้เป็นผลิตภัณฑ์และรายการวัตถุดิบใหม่",
  addVariant: "เพิ่มตัวเลือก",
  addedStock: "สต๊อกที่เพิ่ม",
  adjustQuantity: "ปรับปริมาณ",
  adjustTheSupplyItemsVariant: "ปรับรายการวัตถุดิบและปริมาณสำหรับตัวเลือกเฉพาะนี้",
  all: "ทั้งหมด",
  allAccountTypes: "ประเภทบัญชีทั้งหมด",
  allCategories: "หมวดหมู่ทั้งหมด",
  allDevices: "อุปกรณ์ทั้งหมด",
  allDevicesUsed: "อุปกรณ์ทั้งหมดที่ใช้",
  allDiscounts: "ส่วนลดทั้งหมด",
  allGuestProfiles: "โปรไฟล์แขกทั้งหมด",
  allLocation: "ตำแหน่งทั้งหมด",
  allLocations: "ตำแหน่งทั้งหมด",
  allMeasurements: "ปริมาณทั้งหมด",
  allPaymentMethods: "ช่องทางการชำระเงินทั้งหมด",
  allProducts: "ผลิตภัณฑ์ทั้งหมด",
  allReportsReadyForDownload: "รายงานทั้งหมดพร้อมสำหรับการดาวน์โหลด",
  allRightsReserved: "สงวนลิขสิทธิ์",
  allRoles: "หน้าที่ทั้งหมด",
  allSafeToDeleteLocation: "ไม่มีปัญหา! ไม่มีผลิตภัณฑ์ที่มีตำแหน่งนี้",
  allSelectedAvailablePos: "ผลิตภัณฑ์ที่เลือกทั้งหมดจะพร้อมให้บริการ ณ จุดขาย",
  allSelectedNotPos: "ผลิตภัณฑ์ที่เลือกทั้งหมดจะไม่แสดง ณ จุดขายของคุณ",
  allShiftsClosed: "กะทั้งหมดที่ปิด",
  allStaff: "พนักงานทั้งหมด",
  allStatus: "สถานะทั้งหมด",
  allStockLevels: "ระดับสต๊อกทั้งหมด",
  allTransactions: "ธุรกรรมทั้งหมด",
  allVoucherTypes: "ประเภทคูปองทั้งหมด",
  allVouchers: "คูปองทั้งหมด",
  allowAccess: "อนุญาตการเข้าถึง",
  allowAccessAndConnect: "อนุญาตการเข้าถึงและเชื่อมต่อ",
  allowGuestWBKeeping: "อนุญาตให้แขกเก็บแท็กไว้เมื่อเช็คเอาท์",
  allowOrRestrictGuestWBKeeping: "อนุญาตหรือห้ามแขกเก็บแท็กเมื่อเช็คเอาท์",
  allowPostpaidAndLimit: "อนุญาตเครดิตชำระเงินที่หลังและกำหนดวงเงิน",
  allowPostpaidInGuestProfile:
    "อนุญาตให้โปรไฟล์แขกรายนี้ทำการซื้อโดยไม่มีเครดิต พวกเขาจะถูกเรียกเก็บเงินเมื่อเช็คเอาท์จากสถานที่",
  allowThisGuestProfileLimit:
    "อนุญาตให้โปรไฟล์แขกรายนี้ทำการซื้อโดยไม่มีเครดิต พวกเขาจะถูกเรียกเก็บเงินเมื่อเช็คเอาท์จากสถานที่",
  allowedPaymentMethod: "วิธีการชำระเงินที่อนุญาต",
  almostThere: "เกือบเสร็จแล้ว!",
  alreadyExists: "มีอยู่แล้ว",
  amount: "จำนวน",
  and: "และ",
  andWouldBe: "และจะเป็น",
  anyMoreQuestions: "มีคำถามเพิ่มเติมหรือไม่? {0}",
  applyFilter: "ใช้ตัวกรอง",
  areYouSureYouWantToDeleteLocation:
    "คุณแน่ใจหรือว่าต้องการลบ {0}? ปัจจุบันตำแหน่งนี้มีมูลค่าสินค้าคงคลังเป็น {1}",
  areYouSureYouWantToDeleteProduct:
    "คุณแน่ใจหรือว่าต้องการลบ {0}? รายการวัตถุดิบนี้มีอยู่ในสต๊อก {1} {2} รายการ",
  areYouSureYouWantToDeleteProduct2:
    "คุณแน่ใจหรือว่าต้องการลบ {0}? จะไม่มีให้บริการในสถานที่ของคุณอีกต่อไป ธุรกรรมและรายงานก่อนหน้านี้จะไม่ได้รับผลกระทบ",
  areYouSureYouWantToRemoveVariant:
    "คุณแน่ใจหรือไม่ว่าต้องการลบตัวเลือก “{0}” รายการวัตถุดิบจะไม่ถูกลบออก",
  arrivalDate: "วันที่มาถึง",
  arrivals: "มาถึง",
  askDeleteGuestProfile: "ลบโปรไฟล์แขก?",
  askDeleteStaffProfile: "ลบโปรไฟล์พนักงาน?",
  askGuestInfoCheckIn: "สอบถามข้อมูลของแขกขณะเช็คอิน",
  assemble: "การผลิต",
  assembleAProduct: "ผลิตภัณฑ์ที่ผ่านการผลิต",
  asset: "สินทรัพย์",
  assignAProfile: "กำหนดโปรไฟล์",
  assignFreeCreditsStaff: "ให้เครดิตฟรีแก่พนักงานในกลุ่มนี้",
  assignVoucherStaff: "มอบหมายคูปองให้กับพนักงานในกลุ่มนี้",
  assignVoucherToGuest: "กำหนดคูปองให้กับแขกในกลุ่มนี้เมื่อลงทะเบียน",
  assignedRooms: "ห้อง/เตียงที่กำหนด",
  assignedSpace: "พื้นที่ที่กำหนด",
  attribute: "คุณลักษณะ",
  attributeAlreadyExists: "มีชื่อลักษณะอยู่แล้วในผลิตภัณฑ์นี้",
  automaticallyGenerateSku: "สร้าง SKU อัตโนมัติ",
  availability: "การให้บริการ",
  availabilityOnPos: "การให้บริการ ณ จุดขาย",
  availableAnytime: "มีให้บริการตลอดเวลา",
  availableEveryday: "มีให้บริการทุกวัน",
  availableOnPos: "มีให้บริการ ณ จุดขาย",
  averageAmountPerItem: "จำนวนเฉลี่ยต่อรายการ",
  averageDurationOfStay: "ระยะเวลาการเข้าพักโดยเฉลี่ย",
  averageOrderValue: "มูลค่าการสั่งซื้อโดยเฉลี่ย",
  awaitingInviteResponse: "รอการตอบกลับคำเชิญ",
  back: "กลับ",
  banATag: "ปิดใช้งานแท็ก",
  banDetails: "รายละเอียดการปิด",
  banList: "รายการที่ถูกปิด",
  banTag: "ปิดใช้งานแท็ก",
  banTagListSettings: "ตั้งค่ารายการปิดแท็ก",
  banTags: "ปิดใช้งานแท็ก",
  bannedBy: "ปิดใช้งานโดย",
  bannedTags: "แท็กที่ปิดใช้งาน",
  banningThisTagWillOnlyTakeEffect:
    "การปิดแท็กนี้จะมีผลในครั้งถัดไปที่อุปกรณ์ของคุณซิงค์และอัปเดต (โดยปกติทุกๆ 5 นาทีเมื่อเชื่อมต่ออินเทอร์เน็ต) เพื่อให้การเปลี่ยนแปลงเหล่านี้มีผลใช้งานทันที โปรดซิงค์และอัปเดตอุปกรณ์ของคุณเมื่อคุณปิดใช้งานแท็กนี้",
  basicInfo: "ข้อมูลพื้นฐาน",
  belowParLevel: "ต่ำกว่าปริมาณขั้นต่ำ",
  billAmount: "จำนวนบิล",
  birthdate: "วันที่เกิด",
  birthday: "วันเกิด",
  bookedBy: "จองโดย",
  bookingAmount: "ยอดจอง",
  bookingDescription: "ติดตามการจองทุกรายการในสถานที่ของคุณ",
  bookingDetails: "รายละเอียดการจอง",
  bookingId: "รหัสการจอง",
  bookingList: "รายการจอง",
  bookingNo: "หมายเลขการจอง",
  bookingSummary: "สรุปการจอง",
  bookings: "การจอง",
  bottle: "ขวด",
  browseProducts: "เรียกดูผลิตภัณฑ์",
  browseVouchers: "เรียกดูคูปอง",
  businessAddress: "ที่อยู่สถานที่ทำงาน",
  businessContactNumber: "เบอร์ติดต่อธุรกิจ",
  businessDay: "วันทำการ",
  businessName: "ชื่อธุรกิจ",
  byAssemblingAProduct:
    "ในการผลิตสินค้า คุณสามารถผลิตสินค้าที่มีรายการวัตถุดิบหลากหลาย รวมถึงรายละเอียดวัตถุดิบแต่ละรายการที่มีหลายตัวเลือก",
  byCreatingPrinterProfiles:
    "ในการสร้างโปรไฟล์เครื่องพิมพ์ คุณสามารถตั้งค่าผลิตภัณฑ์ที่จะสั่งปริ้นในสลิปสำหรับจุดให้บริการต่างๆ ในสถานที่ เช่น ห้องครัว บาร์ และอื่นๆ",
  cancel: "ยกเลิก",
  cancelBanTag: "ยกเลิกการปิดใช้งานแท็ก",
  cancelled: "ยกเลิกแล้ว",
  cannotBeDeleted: "ลบไม่ได้",
  cannotDeletePartOfComposite: "ไม่สามารถลบ {0} ได้เนื่องจากเป็นส่วนหนึ่งของ {1} ส่วนประกอบของ {2}",
  cantFindDesc: "ไม่พบสิ่งที่คุณกำลังมองหา? ลองใช้การค้นหาหรือตัวกรองอื่น",
  capacity: "ความจุ",
  card: "การ์ด",
  cash: "เงินสด",
  categories: "หมวดหมู่",
  categoriesDeleted: "ลบ {0} หมวดหมู่แล้ว",
  categorizeAndManage: "จัดหมวดหมู่และจัดการทุกธุรกรรมด้วยผังบัญชี",
  category: "หมวดหมู่",
  categoryCreated: 'สร้างหมวดหมู่ "{0}" แล้ว',
  categoryDeleted: 'ลบหมวดหมู่ "{0}" แล้ว',
  categoryList: "รายการหมวดหมู่",
  categoryName: "ชื่อหมวดหมู่",
  categoryNameAlreadyExist: "มีชื่อหมวดหมู่นี้แล้ว",
  categoryReport: "รายงานหมวดหมู่",
  categoryUpdated: 'อัปเดตหมวดหมู่ "{0}" แล้ว',
  change: "เปลี่ยน",
  changePassword: "เปลี่ยนรหัสผ่าน",
  changePhoto: "เปลี่ยนรูป",
  changesSaved: "บันทึกการเปลี่ยนแปลงแล้ว",
  changingCurrencyWontAffect:
    "การเปลี่ยนสกุลเงินจะไม่ส่งผลต่อมูลค่าราคาผลิตภัณฑ์ของคุณ สัญลักษณ์สกุลเงินเท่านั้นที่เปลี่ยน",
  chargeTaxesOnThisProduct: "เรียกเก็บภาษีสำหรับผลิตภัณฑ์นี้",
  chartOfAccounts: "ผังบัญชี",
  chartOfAccountsDescription: "อัปเดตและจัดการผังบัญชีของคุณ",
  checkInDate: "วันที่เช็คอิน",
  checkInDetails: "รายละเอียดการเช็คอิน",
  checkInQuestions: "คำถามในการเช็คอิน",
  checkInSettings: "การตั้งค่าการเช็คอิน",
  checkIns: "เช็คอิน",
  checkOutDetails: "รายละเอียดการเช็คเอาท์",
  checkOutTheGuide: "ดูคำแนะนำในการเชื่อมต่อการผสานงาน",
  checkOuts: "เช็คเอาท์",
  checkStocks: "ตรวจสอบสต๊อก",
  checkYourEmail: "ตรวจสอบอีเมลของคุณ",
  checkYourEmailAt: "ตรวจสอบอีเมลของคุณที่ {0} เพื่อตั้งค่าบัญชีของคุณให้เสร็จสมบูรณ์",
  checkYourEmailOrAdmin: "ตรวจสอบอีเมลของคุณหรือติดต่อผู้ดูแลระบบของคุณ",
  checkbox: "กล่องเครื่องหมาย",
  checkedIn: "เช็คอิน",
  checkedInBy: "เช็คอินโดย",
  checkedInDate: "วันที่เช็คอิน",
  checkedOut: "เช็คเอาท์",
  checkedOutBy: "เช็คเอาท์โดย",
  checkedOutDate: "วันที่เช็คเอาท์",
  checkedOutOn: "เช็คเอาท์เมื่อ",
  checkinId: "รหัสเช็คอิน",
  checkingYourInternet: "กำลังตรวจสอบการเชื่อมต่ออินเทอร์เน็ตหรือข้อมูลของคุณ",
  checkout: "เช็คเอาท์",
  chooseAPassword: "ใช้รหัสผ่านที่ปลอดภัยซึ่งไม่ได้ใช้ที่อื่น",
  chooseAReason: "เลือกเหตุผล",
  chooseASimpleOrMultipleItem: "เลือกวัตถุดิบรายการเดียวหรือหลายรายการเพื่อผลิตสินค้า",
  chooseAVenue: "เลือกสถานที่",
  chooseAtleast1Location: "เลือกตำแหน่งอย่างน้อย 1 แห่ง",
  chooseCategoryColor: "เลือกสีหมวดหมู่",
  chooseColumns: "เลือกคอลัมน์ที่คุณต้องการดูในรายงานนี้",
  chooseInformation: "เลือกข้อมูลที่จะรวมไว้ในรายละเอียดการขาย",
  chooseLocationForThisStaff: "เลือกการกำหนดตำแหน่งสำหรับพนักงานนี้",
  choosePassword: "เลือกรหัสผ่าน",
  choosePaymentMethod: "เลือกวิธีการชำระเงิน",
  chooseProductsCanBeDiscounted: "เลือกสินค้าจากคลังของคุณที่สามารถลดราคาได้",
  chooseRole: "กำหนดหน้าที่สำหรับพนักงานคนนี้",
  chooseTheLocationWhereThisProduct:
    "เลือกตำแหน่งที่จำหน่ายผลิตภัณฑ์นี้และตำแหน่งที่วัตถุดิบถูกหัก",
  chooseVouchers: "เลือกคูปอง",
  cityStateCountry: "อำเภอ จังหวัด ประเทศ รหัสไปรษณีย์",
  clear: "ล้าง",
  clearAllFilters: "ล้างตัวกรองทั้งหมด",
  clearDownloads: "ล้างการดาวน์โหลด",
  clearedTags: "แท็กที่ล้างแล้ว",
  clearedUnusedAndExpiredCredits: "เครดิตที่หมดอายุ ไม่ได้ใช้ และถูกล้าง",
  clearedUnusedAndExpiredCreditsMessage:
    "สำหรับเครดิตที่เติมเงิน แต่ถูกล้าง ไม่สามารถขอคืนเงินได้ หรือหมดอายุ",
  clearedUnusedAndExpiredCreditsPlaceholder: "[xxxx] - รายได้อื่น (วันหมดอายุ)",
  clearedUnusedExpiredCredit: "รายได้อื่น (วันหมดอายุ)",
  clickHereToRetry: "คลิกที่นี่เพื่อลองอีกครั้ง",
  closePreview: "ปิดการแสดงตัวอย่าง",
  closeReceiptPreview: "ปิดตัวอย่างใบเสร็จ",
  code: "รหัส",
  coffeeBeans: "เมล็ดกาแฟ",
  columns: "คอลัมน์",
  combineYourProducts: "รวมผลิตภัณฑ์ของคุณเพื่อขายเป็นชุด",
  communityGuidelines: "หลักเกณฑ์ของชุมชน",
  companyDetails: "รายละเอียดบริษัท",
  completeStocktake: "ตรวจนับสต็อคให้เสร็จ",
  completeStocktakeConfirmation: "ทำ{0}ให้เสร็จ?",
  completeSubscription: "สมัครสมาชิกให้สมบูรณ์",
  completeYourSubscription: "สมัครสมาชิกให้สมบูรณ์เพื่อเข้าถึงสถานที่ของคุณ",
  completed: "เสร็จแล้ว",
  completedBy: "เสร็จโดย",
  completedOn: "เสร็จเมื่อ",
  composite: "ส่วนประกอบ",
  composition: "ส่วนประกอบ",
  compositionGuide: "คู่มือการจัดส่วนประกอบ",
  confirmPassword: "ยืนยันรหัสผ่าน",
  confirmed: "ยืนยันแล้ว",
  connectAndInstall: "เชื่อมต่อและติดตั้ง",
  connected: "เชื่อมต่อแล้ว",
  contactNumber: "เบอร์ติดต่อ",
  contactUs: "ติดต่อเรา",
  contactUs2: "ติดต่อเรา",
  continue: "ดำเนินการต่อ",
  continueAs: "ดำเนินการต่อในชื่อ {0}",
  continueBanningThisTag: "ปิดการใช้งานแท็กนี้ต่อไปหรือไม่?",
  continuingOnThisPageWillLogout: "การดำเนินการต่อในหน้านี้จะออกจากระบบเซสชันปัจจุบันของคุณ",
  copied: "คัดลอกแล้ว!",
  copyLink: "คัดลอกลิงก์",
  copyrightYear: "ลิขสิทธิ์ © 2021",
  costOfGoodsSold: "ต้นทุนขาย (COGS)",
  costOfGoodsSoldMessage: "บัญชีเริ่มต้นสำหรับต้นทุนของวัตถุดิบเมื่อขายได้",
  costOfGoodsSoldPlaceholder: "[xxxx] - COGS/COGS",
  country: "ประเทศ",
  createALocation: "สร้างตำแหน่ง",
  createAccount: "สร้างบัญชี",
  createAndManageProducts: "สร้างและจัดการผลิตภัณฑ์ที่ขายได้ในตำแหน่งของคุณ",
  createAndManageRawMaterials: "สร้างและจัดการรายการวัตถุดิบและสินค้าคงคลังสำหรับแต่ละตำแหน่ง",
  createAndManagerDiscounts: "สร้างและจัดการส่วนลดของคุณด้วยผลิตภัณฑ์ลดราคา",
  createAndManagerVouchers: "สร้างและจัดการคูปองของคุณเพื่อใช้ในการแลกผลิตภัณฑ์",
  createCategoriesToLink: "สร้างหมวดหมู่เพื่อเชื่อมโยงและจัดหมวดหมู่ผลิตภัณฑ์ของคุณ",
  createCategory: "สร้างหมวดหมู่",
  createDiscountPage: "สร้างหน้าส่วนลด",
  createLocation: "สร้างตำแหน่ง",
  createLocationToStoreYourProducts: "สร้างตำแหน่งสำหรับจัดเก็บผลิตภัณฑ์ของคุณ",
  createNewCategory: "สร้างหมวดหมู่ใหม่",
  createNewDiscount: "สร้างส่วนลดใหม่",
  createNewGuestProfile: "สร้างโปรไฟล์แขกใหม่",
  createNewLocation: "สร้างตำแหน่งใหม่",
  createNewProduct: "สร้างผลิตภัณฑ์ใหม่",
  createNewProductSet: "สร้างชุดผลิตภัณฑ์ใหม่",
  createNewProfile: "สร้างโปรไฟล์ใหม่",
  createNewStaffProfile: "สร้างโปรไฟล์พนักงานใหม่",
  createNewStocktake: "สร้างการเช็คสต๊อกใหม่",
  createNewSupplyItem: "สร้างรายการวัตถุดิบ",
  createNewVoucher: "สร้างคูปองใหม่",
  createNote: "สร้างหมายเหตุ",
  createPrinterProfile: "สร้างโปรไฟล์เครื่องพิมพ์",
  createProduct: "สร้างผลิตภัณฑ์",
  createProductSet: "สร้างชุดผลิตภัณฑ์",
  createStaffProfile: "สร้างโปรไฟล์พนักงาน",
  createStaffWhoCan: "สร้างพนักงานที่สามารถเติมเครดิต ลงทะเบียนแขก และขายในสถานที่ของคุณ",
  createTheProduct: "สร้างผลิตภัณฑ์เพื่อขายในสถานที่ของคุณ",
  createVoucherPage: "สร้างหน้าคูปอง",
  createVouchersForGuest: "สร้างคูปองเพื่อให้แขกและพนักงานของคุณใช้!",
  createYourOwnIntegration: "สร้างการผสานการทำงานของคุณเองด้วย PouchCONNECT",
  createYourVenue: "สร้างสถานที่ของคุณ",
  createdSupplyItem: "สร้างรายการวัตถุดิบ",
  credit: "เครดิต",
  creditAutomaticallyExpires: "เครดิตจะหมดอายุโดยอัตโนมัติหลังจากเช็คเอาท์",
  creditBalance: "ยอดเครดิตคงเหลือ",
  creditLimits: "วงเงินเครดิต",
  creditSettings: "การตั้งค่าเครดิต",
  credits: "เครดิต",
  creditsDescription: "กำหนดเครดิตฟรีให้แก่แขกในกลุ่มนี้และกำหนดวงเงินเครดิตแบบชำระภายหลัง",
  creditsExpiration: "วันหมดอายุเครดิต",
  creditsExpirationDescription: "ตั้งค่าเครดิตให้หมดอายุเมื่อแขกเช็คเอาท์",
  creditsExpirationOnCheckout: "เครดิตหมดอายุเมื่อเช็คเอาท์",
  creditsLiabilityAccount: "บัญชีความรับผิดชอบเครดิต",
  creditsLiabilityAccountMessage: "บัญชีสำหรับเครดิตทั้งหมดที่เติมในแท็กก่อนการขาย",
  creditsLiabilityAccountPlaceholder: "[xxxx] - ความรับผิดชอบ/เครดิต",
  creditsNeverExpires: "เครดิตไม่มีวันหมดอายุหลังจากเช็คเอาท์",
  creditsWouldNeverExpire: "เครดิตจะไม่มีวันหมดอายุเมื่อผู้เข้าพักอยู่ในระหว่างการเช็คอิน",
  currency: "สกุลเงิน",
  currencyAndFormat: "สกุลเงินและรูปแบบ",
  currentGuestProfiles: "โปรไฟล์แขกปัจจุบัน",
  currentPassword: "รหัสผ่านปัจจุบัน",
  currentPasswordAndNewPasswordMatched: "รหัสผ่านปัจจุบันและรหัสผ่านใหม่ตรงกัน",
  custom: "กำหนดเอง",
  customDateTime: "กำหนดช่วงวันที่และเวลาเอง",
  customFields: "ช่องว่างที่กำหนดเอง",
  customQuestion: "คำถามที่กำหนดเอง",
  customQuestions: "คำถามที่กำหนดเอง",
  customTax: "กำหนดภาษีเอง",
  customerBehaviourOverTime: "พฤติกรรมลูกค้าล่วงเวลา",
  customizeReceipt: "ปรับแต่งแต่ละส่วนของใบเสร็จของคุณ",
  customizeSectionReceipt: "ปรับแต่งส่วนต่างๆ ของใบเสร็จของคุณ",
  dashboard: "แผงควบคุม",
  date: "วันที่",
  dateAndTimeOfTransaction: "วันที่และเวลาที่ทำรายการ",
  dateBanned: "วันที่ปิดใช้งาน",
  dateCreated: "วันที่สร้าง",
  dateIssuedWithColonSymbol: "วันที่ออก:",
  dateModified: "วันที่แก้ไข",
  dateOfCheckin: "วันที่เช็คอิน",
  dateOfCheckout: "วันที่เช็คเอาท์",
  dateOfRegistration: "วันที่ลงทะเบียน",
  dateRange: "ช่วงวันที่",
  day: "วัน",
  days: "วัน",
  daysAfterCheckout: "วันหลังจากเช็คเอาท์",
  debitCredit: "บัตรเดบิต/เครดิต",
  default: "ค่าเริ่มต้น",
  defaultAccountForTaxes: "บัญชีเริ่มต้นสำหรับภาษีที่เรียกเก็บสำหรับแต่ละผลิตภัณฑ์",
  defaultFields: "ช่องว่างเริ่มต้น",
  defaultQuestions: "คำถามเริ่มต้น",
  defaultRevenueAccount: "บัญชีรายได้เริ่มต้น",
  defaultRevenueAccountMessage: "บัญชีเริ่มต้นสำหรับรายได้จากการขายทั้งหมด",
  defaultTax: "ภาษีเริ่มต้น",
  defectiveTag: "แท็กชำรุด",
  defectiveTags: "แท็กชำรุด",
  delete: "ลบ",
  deleteAProduct: "ลบผลิตภัณฑ์",
  deleteAProductSet: "ลบชุดผลิตภัณฑ์",
  deleteAProduct2: "ลบผลิตภัณฑ์?",
  deleteCategories: "ลบ {0} หมวดหมู่",
  deleteCategory: "ลบหมวดหมู่",
  deleteCurrentlyBeingUsed:
    "กำลังใช้{0}ในชุดผลิตภัณฑ์บางชุด หากต้องการดำเนินการต่อ โปรดลบผลิตภัณฑ์นี้ออกจากชุดผลิตภัณฑ์ต่อไปนี้",
  deleteDiscount: "ลบส่วนลด",
  deleteGuestProfile: "ลบโปรไฟล์แขก",
  deleteLocation: "ลบตำแหน่ง",
  deleteLocationNote: "หมายเหตุ: ธุรกรรมก่อนหน้าของคุณกับตำแหน่งนี้จะถูกเก็บไว้",
  deleteName: 'ลบ "{0}" หรือไม่',
  deleteNote: "ลบหมายเหตุ",
  deletePaymentMethod: "ลบวิธีการชำระเงิน",
  deletePrinterProfile: "ลบโปรไฟล์เครื่องพิมพ์",
  deleteProduct: "ลบ{0}หรือไม่?",
  deleteProductSet: "ลบชุดผลิตภัณฑ์หรือไม่?",
  deleteProducts: "ลบผลิตภัณฑ์ {0} รายการหรือไม่?",
  deleteProducts2: "ลบผลิตภัณฑ์ {0} รายการ",
  deleteQuesiton: "ลบคำถาม",
  deleteSelectedCategories: "ลบหมวดหมู่ที่เลือก",
  deleteSelectedCategory: "ลบหมวดหมู่ที่เลือก",
  deleteSelectedProduct: "ลบผลิตภัณฑ์ที่เลือก",
  deleteSelectedProducts: "ลบผลิตภัณฑ์ที่เลือก",
  deleteStaff: "ลบพนักงาน",
  deleteStaffProfile: "ลบโปรไฟล์พนักงาน",
  deleteSupplyItem: "ลบรายการวัตถุดิบ",
  deleteTax: "ลบภาษี",
  deleteThis: "ลบ {0} นี้",
  deleteThisMultiple: "ลบ {0} {1} หรือไม่?",
  deleteThisQuestion: "ลบคำถามนี้หรือไม่?",
  deleteVoucher: "ลบคูปอง",
  deleted: "ลบแล้ว",
  deletedPaymentMethod: 'ลบวิธีการชำระเงิน "{0}" แล้ว',
  deletedTax: 'ลบภาษี "{0}" แล้ว',
  deletingLoading: "กำลังลบ...",
  deletingName: "กำลังลบ {0}",
  deletingThisLocation:
    "การลบตำแหน่งนี้จะลบยอดคงเหลือในสต็อคของรายการวัตถุดิบทั้งหมดด้วย การดำเนินการนี้ไม่สามารถยกเลิกได้",
  departure: "การออกเดินทาง",
  departureDate: "วันออกเดินทาง",
  describeThisProduct: "อธิบายผลิตภัณฑ์ชิ้นนี้...",
  describeThisProductSet: "อธิบายชุดผลิตภัณฑ์นี้",
  description: "คำอธิบาย",
  deviceId: "รหัสอุปกรณ์",
  deviceImei: "อุปกรณ์ IMEI",
  deviceImeiSerial: "อุปกรณ์ IMEI / Serial",
  deviceInfo: "ข้อมูลอุปกรณ์",
  deviceList: "รายการอุปกรณ์",
  deviceMac: "ที่อยู่ MAC ของอุปกรณ์",
  deviceMacAddress: "ที่อยู่ MAC ของอุปกรณ์",
  deviceName: "ชื่ออุปกรณ์",
  deviceNameAlreadyExists: "มีชื่ออุปกรณ์นี้แล้ว",
  deviceNameUpdated: "อัปเดตอุปกรณ์ “{0}” แล้ว",
  deviceSerialNumber: "หมายเลขซีเรียลชอุปกรณ์",
  devices: "อุปกรณ์",
  difference: "แตกต่าง",
  disableSellingOnPos: "ปิดการใช้งาน POS",
  discard: "ยกเลิก",
  discardChanges: "ยกเลิกการเปลี่ยนแปลง",
  discardWristbandKeepingSettings: "ยกเลิกการตั้งค่าการรักษาสายรัดข้อมือ",
  disclaimerCategoryReport:
    "การปฏิเสธความรับผิด: ผลิตภัณฑ์บางรายการอาจถูกกำหนดหมวดหมู่ไว้หลายหมวดหมู่ซึ่งจะส่งผลให้มีการนับซ้ำในแต่ละรายการ",
  disconnect: "ตัดการเชื่อมต่อ",
  discount: "การลดราคา",
  discountApplied: "ใช้ส่วนลดแล้ว",
  discountCanBeApplied: "ส่วนลดนี้สามารถใช้ได้ในสถานที่ของคุณ",
  discountCreated: 'สร้างส่วนลด "{0}" แล้ว',
  discountDeleted: 'ลบส่วนลด "{0}" แล้ว',
  discountName: "ชื่อส่วนลด",
  discountNameAlreadyExist: "ชื่อส่วนลดนี้มีอยู่แล้ว",
  discountRateOrValue: "อัตราส่วนลดหรือมูลค่า",
  discountReport: "รายงานส่วนลด",
  discountType: "ประเภทส่วนลด",
  discountUpdated: 'อัปเดตส่วนลด "{0}" แล้ว',
  discountableProducts: "ผลิตภัณฑ์ลดราคา",
  discounts: "ส่วนลด",
  discountsPage: "หน้าส่วนลด",
  discrepancy: "ความคลาดเคลื่อน",
  displayCategoryInPos: "แสดงหมวดหมู่นี้บนอุปกรณ์ POS",
  distribution: "การจัดจำหน่าย",
  done: "เสร็จแล้ว",
  dontSellOnPos: "ห้ามขายที่ POS",
  dontWorry: "ไม่ต้องกังวล!",
  download: "ดาวน์โหลด",
  downloading: "กำลังดาวน์โหลด...",
  dropdown: "เลื่อนลง",
  duplicateOption: "ตัวเลือกซ้ำ",
  easierGuestReg: "การลงทะเบียนและเช็คอินแขกที่ง่ายขึ้น",
  edit: "แก้ไข",
  editAccessToken: "แก้ไขโทเค็นการเข้าถึง",
  editAccount: "แก้ไขบัญชี",
  editCategory: "แก้ไขหมวดหมู่",
  editDevices: "แก้ไขอุปกรณ์",
  editDiscountsPage: "แก้ไขหน้าส่วนลด",
  editGuestProfile: "แก้ไขโปรไฟล์แขก",
  editLocation: "แก้ไขตำแหน่ง",
  editLocations: "แก้ไขตำแหน่ง",
  editNewCategory: "แก้ไขหมวดหมู่ใหม่",
  editNote: "แก้ไขหมายเหตุ",
  editPaymentMethod: "แก้ไขวิธีการชำระเงิน",
  editPaymentMethods: "แก้ไขวิธีการชำระเงิน",
  editPrinter: "แก้ไขโปรไฟล์เครื่องพิมพ์",
  editProduct: "แก้ไขผลิตภัณฑ์",
  editProductSet: "แก้ไขชุดผลิตภัณฑ์",
  editQuestions: "แก้ไขคำถาม",
  editStaff: "แก้ไขพนักงาน",
  editStaffPage: "แก้ไขหน้าพนักงาน",
  editStaffProfilePage: "แก้ไขหน้าโปรไฟล์พนักงาน",
  editSupplyItem: "แก้ไขรายการวัตถุดิบ",
  editTax: "แก้ไขภาษี",
  editVariants: "แก้ไขตัวเลือก",
  editVoucherPage: "แก้ไขหน้าคูปอง",
  editYourAccountPreferences: "แก้ไขการตั้งค่าบัญชี ที่อยู่อีเมล และรหัสผ่านของคุณ",
  egAppliesToGuests: "เช่น ใช้กับผู้เข้าพักที่มีอายุ 60 ปีขึ้นไป",
  egSeniorDiscount: "เช่น ส่วนลดอาวุโส",
  egSizeFlavor: "เช่น ขนาด รสชาติ",
  eightCharactersMinimum: "อย่างน้อย 8 ตัวอักษร",
  eitherYouHavePoorConnection:
    "อาจเกิดจากการเชื่อมต่อเครือข่ายของคุณไม่ดี การเข้าถึงของคุณถูกปฏิเสธ หรือมีบางอย่างผิดพลาดจากฝั่งเรา",
  email: "อีเมล",
  emailAddress: "ที่อยู่อีเมล",
  emailAlreadyInVenue: "อีเมลนี้เชื่อมโยงกับบัญชีในสถานที่นี้แล้ว",
  emailDoesntHaveRecord: "อีเมลที่คุณป้อนไม่ตรงกับบันทึกของเรา โปรดตรวจสอบและลองอีกครั้ง",
  enableSellingOnPos: "เปิดใช้งานการขายบน POS",
  end: "จบ",
  endDay: "จบวัน",
  endOfDay: "ประจำวัน",
  endOfDayChecklist: "รายการตรวจสอบประจำวัน",
  endOfDayReports: "รายงานประจำวัน",
  enterEachOption: "ป้อนแต่ละตัวเลือกโดยคั่นด้วยเครื่องหมายจุลภาค",
  enterEmailToLogin: "ป้อนที่อยู่อีเมลของคุณเพื่อลงทะเบียนหรือเข้าสู่ระบบ",
  enterYourEmailAddress: "ป้อนที่อยู่อีเมลของคุณ",
  enterYourPassword: "ป้อนรหัสผ่านของคุณ",
  enteredPasswordIncorrect: "รหัสผ่านที่ป้อนไม่ถูกต้อง",
  equity: "ทุน",
  errorLoadingColors: "เกิดข้อผิดพลาดในการโหลดสี โปรดลองอีกครั้งในภายหลัง",
  example1: "ตัวอย่างที่ 1",
  example1AssembleProduct:
    "{0}: Cafe Latte ต้องการมี {1}, {2} และ {3} สินค้าคงคลังจะถูกหักออกจากเมล็ดกาแฟ นม และน้ำตาลเมื่อซื้อ Cafe Latte",
  example2: "ตัวอย่าง 2",
  example2AssembleProduct:
    '{0}: ไวน์สามารถขายเป็น {1} หรือ {2} เลือกไวน์เป็นรายการวัตถุดิบ จากนั้นสร้างตัวเลือกเป็น "ขวด" และ "แก้ว" และปรับปริมาณของตัวเลือกแต่ละอัน ดังนั้นปริมาณจะถูกหักออกจากรายวัตถุดิบตามตัวเลือก',
  expStockQty: "จำนวนสต็อคที่หมดอายุ ",
  expectedEndingBalance: "ยอดคงเหลือที่คาดการณ์",
  expectedQty: "จำนวนที่คาดการณ์",
  expense: "ค่าใช้จ่าย",
  expired: "หมดอายุ",
  export: "ส่งออก",
  exportCheckinDetails: "ส่งออกรายละเอียดการเช็คอิน",
  exportRegisterReport: "ส่งออกรายงานการลงทะเบียน",
  exportTransactions: "ส่งออกรายการธุรกรรม",
  exportXlsx: "ส่งออกเป็น XLSX",
  extendThePower: "เพิ่มประสิทธภาพการทำงานของ PouchVENUE ด้วยส่วนเสริมที่ดีที่สุด",
  failed: "ล้มเหลว",
  failedToLoad: "โหลดไม่สำเร็จ",
  feedback: "ข้อเสนอแนะ",
  feelFreeToContactPouchnation: "สามารถติดต่อเราได้ที่ PouchNATION",
  filters: "ตัวกรอง",
  firstName: "ชื่อจริง",
  fixedAmount: "จำนวนเงินคงที่",
  fixedAmountRange: "จำนวนเงินคงที่ควรอยู่ระหว่าง 1-9,999,999",
  footerSection: "ส่วนท้าย",
  forApproval: "เพื่อการอนุมัติ",
  forceBanned: "บังคับเช็คเอาท์และรายละเอียดการสั่งห้าม",
  forceCheckOutBy: "บังคับให้เช็คเอาท์โดย",
  forceCheckout: "บังคับเช็คเอาท์",
  forceCheckoutDetails: "รายละเอียดการบังคับเช็คเอาท์",
  forceCheckoutName: "บังคับเช็คเอาท์ {0}?",
  forcedCheckedOutBy: "บังคับให้เช็คเอาท์โดย",
  formatting: "การจัดรูปแบบ",
  freeCredits: "เครดิตฟรี",
  freeCreditsAreCreditsThatAreFreeOfCharge:
    "เครดิตฟรีคือเครดิตที่ไม่มีค่าใช้จ่าย เครดิตเหล่านี้คือ",
  freeCreditsHoverTooltip:
    "เครดิตฟรีไม่สามารถขอคืนได้ และจะจัดลำดับเป็นอันดับแรกและถูกใช้ก่อนเมื่อชำระเงิน",
  freeCreditsIssued: "ออกเครดิตฟรี",
  freeCreditsLiabilityAccount: "บัญชีความรับผิดเครดิตฟรี",
  freeCreditsLiabilityAccountMessage: "ค่าใช้จ่ายของเครดิตฟรีที่ออกให้แก่แขกเมื่อใช้แล้ว",
  freeCreditsLiabilityAccountPlaceholder: "[xxxx] - ความรับผิด/เครดิตฟรี",
  freeCreditsRemoved: "เครดิตฟรีลบแล้ว",
  freeTrial: "ทดลองใช้งานฟรี 30 วัน!",
  gender: "เพศ",
  general: "ทั่วไป",
  generalSettings: "การตั้งค่าทั่วไป",
  generatingReport: "กำลังสร้างรายงาน...",
  getNotifications: "รับการแจ้งเตือน",
  getStarted: "เริ่ม",
  glass: "แก้ว",
  glossary: "อภิธานศัพท์",
  goToXDashboard: "ไปที่แดชบอร์ด {0}",
  grossProfit: "กำไรขั้นต้น",
  guest: "แขก",
  guestCheckedOutAndBanned: "แขกเช็คเอาท์และปิดการใช้งานแท็ก",
  guestDetails: "รายละเอียดแขก",
  guestInfoNotYetSync: "ยังไม่ได้ซิงค์ข้อมูลแขก",
  guestInformationYouCollect: "ข้อมูลแขกที่คุณรวบรวมไว้เมื่อเช็คอิน",
  guestList: "รายชื่อแขก",
  guestName: "ชื่อแขก",
  guestNameAndOrTagId: "ชื่อแขกและ/หรือรหัสแท็ก",
  guestOrTagStatus: "สถานะแขกหรือแท็ก",
  guestProfile: "โปรไฟล์แขก",
  guestProfileDeleted: "โปรไฟล์แขกลบแล้ว",
  guestProfileDescriptionPlaceholder: "เช่น “แขกที่เช็คอินในศูนย์อาหาร”",
  guestProfileList: "รายการโปรไฟล์แขก",
  guestProfileName: "ชื่อโปรไฟล์แขก",
  guestProfileNameCreate: "สร้างโปรไฟล์แขก “{0}” แล้ว",
  guestProfileNamePlaceholder: "เช่น “แขกของศูนย์อาหาร”",
  guestProfiles: "โปรไฟล์แขก",
  guestQuestions: "คำถามสำหรับแขก",
  guestSince: "แขกตั้งแต่ {0}",
  guestSpecialRequest: "คำขอพิเศษของแขก",
  guestTap: "แถบสำหรับแขก",
  guestWithColonSymbol: "แขก:",
  guests: "แขก",
  guestsCheckedIn: "แขกเช็คอิน",
  guestsNewBalance: "ยอดคงเหลือใหม่ของแขก",
  guestsPreviousBalance: "ยอดคงเหลือก่อนหน้าของแขก",
  guestsPreviousBalanceTotalPaidAndNewBalance:
    "ยอดคงเหลือก่อนหน้า ยอดชำระทั้งหมด และยอดคงเหลือใหม่",
  headOfBooking: "หัวหน้าฝ่ายจอง",
  headerSection: "ส่วนหัว",
  hello: "สวัสดี",
  hiHeresWhatsHappening: "สวัสดี {0} นี่คือสิ่งที่เกิดขึ้นกับ {1}",
  hidden: "ที่ซ่อนอยู่",
  hide: "ซ่อน",
  hideDetails: "ซ่อนรายละเอียด",
  hideInPos: "ซ่อนที่ POS",
  hideVariant: "ซ่อนตัวเลือก",
  holdingAccoutForToppedUpItems: "บัญชีเงินฝากสำหรับเครดิตทั้งหมดที่เติมในแท็กก่อนการขาย",
  hour: "ชั่วโมง",
  hours: "ชั่วโมง",
  id: "ID",
  ifYouLeaveThisPage:
    "หากคุณออกจากหน้านี้ การเปลี่ยนแปลงที่ไม่ได้บันทึกทั้งหมดจะสูญหายไป คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการเปลี่ยนแปลง",
  ifYoudLikeToJustStopSellingProduct:
    "หากคุณต้องการหยุดขายผลิตภัณฑ์บน POS ของคุณ เพียงแค่ปิดการใช้งานโดยปิด “ขายบน POS”",
  imageTypeSize: "JPG GIF หรือ PNG ขนาดสูงสุดของ1MB",
  in: "ใน",
  inProgress: "กำลังดำเนินการ",
  inStock: "มีสินค้า",
  inactive: "ไม่ใช้งาน",
  include: "รวม",
  indeterminate: "ไม่แน่นอน",
  information: "ข้อมูล",
  informationToCollect: "ข้อมูลที่จะรวบรวมเมื่อลงทะเบียนแขก",
  integrateDesc: "ผสานรวมกับระบบการจัดการทรัพย์สินอันทรงพลังและอื่น ๆ",
  integrationSettingDesc:
    "เชื่อมต่อกับธุรกิจและแอปเพิ่มประสิทธิภาพอื่นๆ เพื่อช่วยให้คุณเติบโตและปรับปรุงธุรกิจของคุณ",
  integrationSettings: "การตั้งค่าการผสานรวม",
  integrations: "ผสานรวม",
  invalidFileType: "ประเภทไฟล์ไม่ถูกต้อง ประเภทไฟล์ที่อนุญาตคือ JPG หรือ PNG",
  invalidOptions: "ตัวเลือกที่ไม่ถูกต้อง",
  invalidTimeRange: "ช่วงเวลาที่ไม่ถูกต้อง",
  invalidToken: "โทเค็นไม่ถูกต้อง",
  inventory: "สินค้าคงคลัง",
  inventoryAccount: "บัญชีสินค้าคงคลัง",
  inventoryAccountMessage: "สำหรับรายการอุปทานที่ซื้อและสินค้าคงคลังก่อนขาย",
  inventoryAccountPlaceholder: "[xxxx] - สินทรัพย์/สินค้าคงคลัง",
  inventoryGainLossAccount: "บัญชีกำไร/ขาดทุนของสินค้าคงคลัง",
  inventoryGainLossAccountMessage: "สำหรับความคลาดเคลื่อนในการตรวจนับสต็อค การปรับสต็อค ฯลฯ",
  inventoryGainLossAccountPlaceholder: "[xxxx] - กำไร/ขาดทุนจากการขายสินค้าคงคลัง",
  inventoryManagement: "การจัดการสินค้าคงคลัง",
  inventoryMovement: "การเคลื่อนไหวของสินค้าคงคลัง",
  inventoryMovementPage: "หน้าการเคลื่อนไหวของสินค้าคงคลัง",
  inventoryReport: "รายงานสินค้าคงคลัง",
  inventoryValue: "มูลค่าสินค้าคงคลัง",
  invitationHasBeenSentTo: "ส่งคำเชิญไปที่ {0} แล้ว",
  inviteNewStaff: "เชิญพนักงานใหม่",
  inviteYourVenueStaff: "เชิญพนักงานของสถานที่ของคุณ จัดการบทบาทและการเข้าถึง POS ของคุณ",
  isAreserveWord: "เป็นคําสํารอง.",
  issuanceLimit: "วงเงินการออก",
  issue: "ปัญหา",
  issueFreeCredits: "ออกเครดิตฟรี",
  issuedBy: "ออกโดย",
  issuedOn: "ออกเมื่อ",
  item: "รายการ",
  itemName: "ชื่อสินค้า",
  itemTax: "ภาษีสินค้า",
  items: "รายการ",
  itemsSold: "สินค้าที่ขาย",
  lastIssuedTo: "ออกล่าสุดแก่",
  lastModifiedBy: "แก้ไขล่าสุดโดย",
  lastModifiedOn: "แก้ไขล่าสุดเมื่อ",
  lastName: "นามสกุล",
  lastPurchasedProduct: "ผลิตภัณฑ์ที่ซื้อล่าสุด",
  lastSync: "ซิงค์ล่าสุด",
  lastSynced: "ซิงค์ล่าสุด {0}",
  lastVisitedLocation: "ตำแหน่งเยี่ยมชมล่าสุด",
  learnMore: "เรียนรู้เพิ่มเติม",
  legalBusinessName: "ชื่อธุรกิจตามกฎหมาย",
  letsGetStarted: "มาเริ่มกันเลย",
  liability: "ความรับผิด",
  limit: "จำกัด",
  limitVoucherPerPerson: "จำกัดการออกคูปองต่อท่าน",
  linkAccountingItem: "เชื่อมโยงรายการบัญชี",
  linkWithMewsAccountingItems: "เชื่อมโยงกับรายการบัญชี MEWS",
  loading: "กำลังโหลด...",
  location: "ที่ตั้ง",
  locationDesignation: "การกำหนดตำแหน่ง",
  locationName: "ชื่อตำแหน่ง",
  locationNameAlreadyExist: "มีตำแหน่งนี้อยู่แล้ว เลือกชื่ออื่น",
  locationNameCreated: 'สร้างตำแหน่ง "{0}" แล้ว',
  locationNameDeleted: 'ลบตำแหน่ง "{0}" แล้ว',
  locationNameUpdated: 'อัปเดตตำแหน่ง "{0}" แล้ว',
  locationVoucherRedeemed: "เลือกตำแหน่งที่จะแลกคูปองนี้",
  locations: "ตำแหน่ง",
  locationsList: "รายการตำแหน่ง",
  logIn: "เข้าสู่ระบบ",
  loginHasEnded: "เซสชั่นการเข้าสู่ระบบของคุณสิ้นสุดแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
  loginSessionEnded: "สิ้นสุดเซสชันการเข้าสู่ระบบ",
  logout: "ออกจากระบบ",
  looksLikeAlreadyInSystem: "ดูเหมือนว่าคุณจะอยู่ในระบบของเราแล้ว!",
  looksLikeYouEncounteredSomething:
    "ดูเหมือนว่าคุณพบข้อผิดพลาด เราจะติดตามข้อผิดพลาดเหล่านี้โดยอัตโนมัติ ในระหว่างนี้ โปรดลองรีเฟรช",
  looksLikeYouHaveNoLocationYet: "ดูเหมือนว่าคุณยังไม่มีที่ตั้ง",
  lostTag: "แท็กที่หาย",
  lostTags: "แท็กที่หาย",
  lowOrOutOfStock: "สต๊อกต่ำหรือหมด",
  lowParLevel: "ระดับ PAR ต่ำ",
  lowerCaseNoneRefundable: "ไม่สามารถคืนเงินได้",
  lowerCaseTopUpCredits: "เครดิตเติมเงิน",
  mailingList: "รายชื่อผู้รับจดหมาย",
  manageAccountNotificationStockLevel: "จัดการบัญชีเพื่อแจ้งเตือนเมื่อรายการลดถึงระดับการแจ้งเตือน",
  manageAndAssignQuestions:
    "จัดการและกำหนดคำถามในการเช็คอิน เครดิตฟรี และคูปองให้กับโปรไฟล์แขกต่างๆ",
  manageBusinessInfo: "จัดการข้อมูลทางธุรกิจ",
  manageEmailNotif: "จัดการอีเมลแจ้งเตือนที่ส่งถึงคุณและพนักงานของคุณ",
  manageHowVenueTax:
    "จัดการการเรียกเก็บภาษีของสถานที่ของคุณโดยขึ้นอยู่กับภูมิภาค ปรึกษากับผู้เชี่ยวชาญด้านภาษีเพื่อทำความเข้าใจการชำระภาษีของคุณ",
  manageImportantDetailsSettings:
    "จัดการรายละเอียดและกฎเกณฑ์ที่สำคัญของสถานที่ของคุณ เช่น การตั้งค่าสถานที่ การตั้งค่าการชำระเงินและเครดิต การตั้งค่าการเช็คอิน และการตั้งค่าบัญชีของคุณ",
  manageInventory: "จัดการสินค้าคงคลัง",
  manageInventoryAndProducts: "จัดการสินค้าคงคลังและผลิตภัณฑ์ของชุดนี้",
  manageInventoryAndSupply: "จัดการสินค้าคงคลังและรายการวัตถุดิบของผลิตภัณฑ์นี้",
  manageNotifcations: "จัดการอีเมลแจ้งเตือนและการแจ้งเตือนที่ส่งถึงพนักงานของคุณ",
  managePlacesYouStock: "จัดการสถานที่ที่คุณสต๊อกสินค้าคงคลังและขายผลิตภัณฑ์",
  manageReceipts: "จัดการลักษณะและข้อมูลที่แสดงบนใบเสร็จของคุณ",
  manageSupplyItems: "จัดการรายการวัตถุดิบ",
  manageThePosDevicesVenue: "จัดการอุปกรณ์ POS ที่เข้าสู่ระบบและกำลังใช้งานในสถานที่ของคุณ",
  manageTheStocksPerLocation: "จัดการสต็อคตามตำแหน่งของรายการวัตถุดิบนี้",
  manageToppedUpCredits: "จัดการเครดิตที่เติม เครดิตฟรี เครดิตแบบรายเดือน และเครดิตที่หมดอายุ",
  manageVariants: "จัดการตัวเลือก",
  manageYourAccountsSales:
    "จัดการบัญชีของคุณเกี่ยวกับการขาย ต้นทุนผลิตภัณฑ์ ภาษีผลิตภัณฑ์ หรือส่วนลด",
  manageYourStaffProfileDescription:
    "จัดการพนักงาน หน้าที่ การมอบหมายหน้าที่ และโปรไฟล์พนักงานที่รับผิดชอบ",
  manageYourVenueSetting: "จัดการการตั้งค่าสถานที่ของคุณ เช่น ภาษีและสกุลเงิน",
  manageYourVenueSubscription:
    "จัดการการสมัครรับข้อมูลสถานที่ของคุณ ข้อมูลการเรียกเก็บเงิน และใบแจ้งหนี้",
  manageYourVenueTax: "เพิ่มและจัดการวิธีที่สถานที่ของคุณเรียกเก็บภาษี",
  manager: "ผู้จัดการ",
  managerAuthorization: "การอนุญาตจากผู้จัดการ",
  mapAndManageAccounts:
    "วางแผนและจัดการบัญชีเริ่มต้นของคุณสำหรับแต่ละกระบวนการทางธุรกิจของ PouchVENUE",
  mapAndManageAccountsLink: "วางแผนและจัดการบัญชีของคุณใน {0} สำหรับการบัญชีที่เหมาะสม",
  mapYourAccounts: "วางแผนการบัญชีของคุณสำหรับสินทรัพย์สินค้าคงคลัง ค่าใช้จ่ายที่ไม่ตรงกัน ฯลฯ",
  margin: "มาร์จิ้น",
  markUp: "มาร์กอัป",
  maximumLengthCharacters: "ระดับสูงสุด {0} ตัวอักษร",
  maximumValueAllowed: "ค่าสูงสุดที่อนุญาตคือ 20,000,000",
  maximumValueIs: "ค่าสูงสุดคือ",
  measurements: "ปริมาณ",
  milk: "นม",
  minOfNCharacters: "ขั้นต่ำ {0} ตัวอักษร",
  minimum: "ขั้นต่ํา",
  minimumCharactersAllowed: "อย่างน้อย {0} อักขระที่ใช้ได้",
  minimumOf: "ขั้นต่ำ 2 รายการที่จำเป็น",
  minimumValueIs: "ค่าต่ําสุดคือ",
  minute: "นาที",
  minutes: "นาที",
  missedCheckIn: "พลาดการเช็คอิน",
  missedCheckOut: "พลาดการเช็คเอาท์",
  mixed: "ผสม",
  mobileNumber: "เบอร์มือถือ",
  month: "เดือน",
  months: "เดือน",
  monthsAfterCheckout: "เดือนหลังจากเช็คเอาท์",
  mostPurchasedProduct: "ผลิตภัณฑ์ที่ซื้อมากที่สุด",
  mostVisitedLocation: "ตำแหน่งที่มากที่สุด",
  movement: "ความเคลื่อนไหว",
  nOptions: "{0} ตัวเลือก",
  nTon: "{0} ถึง {1}",
  name: "ชื่อ",
  nameAdded: "เพิ่ม “{0}” แล้ว",
  nameYourProduct: "ตั้งชื่อผลิตภัณฑ์...",
  nameYourProductSet: "ตั้งชื่อชุดผลิตภัณฑ์ของคุณ...",
  nameYourSupplyItem: "ตั้งชื่อรายการวัตถุดิบของคุณ",
  nationality: "สัญชาติ",
  needHelp: "ต้องการความช่วยเหลือ?",
  netWeightN: "น้ำหนักสุทธิ {0}",
  new: "ใหม่",
  newBalance: "ยอดคงเหลือใหม่",
  newGuests: "แขกใหม่",
  newInviteLink: 'ส่งลิงก์คำเชิญใหม่ไปยัง "{0}" แล้ว',
  newPassWord: "รหัสผ่านใหม่",
  newProduct: "ผลิตภัณฑ์ใหม่",
  newProductSet: "ชุดผลิตภัณฑ์ใหม่",
  newQuantity: "ปริมาณใหม่",
  newToPouchNation: "ยังไม่เคยสมัครสมาชิกกับ PouchNATION ใช่หรือไม่?",
  no: "ไม่",
  noAccountsAvaiable: "ไม่มีบัญชีให้บริการ",
  noAccountsYet: "ยังไม่มีบัญชี",
  noAvailableCategories: "ไม่มีหมวดหมู่",
  noAvailableGuestProfile: "ไม่มีโปรไฟล์แขก",
  noAvailableLocations: "ไม่มีตำแหน่งให้บริการ",
  noAvailableLocationsYet: "ยังไม่มีตำแหน่งให้บริการ",
  noAvailablePaymentMethodYet: "ยังไม่มีวิธีการชำระเงินที่ใช้ได้",
  noAvailableStaff: "ไม่มีพนักงานให้บริการ",
  noBannedTagsYet: "ยังไม่มีแท็กที่ถูกปิดใช้งาน",
  noBookingsYet: "ยังไม่มีการจอง",
  noCheckInsInDateRange: "ไม่มีการเช็คอินในช่วงวันที่นี้",
  noData: "ไม่มีข้อมูล",
  noDeviceAvailable: "ไม่มีอุปกรณ์ให้บริการ",
  noDevicesFound: "ไม่พบอุปกรณ์",
  noEndDate: "ไม่มีวันสิ้นสุด",
  noLocation: "ไม่มีที่ตั้ง",
  noLocationAvailable: "ไม่มีที่ตั้งให้บริการ",
  noNotesFound: "ไม่พบโน้ต",
  noOfGuests: "จำนวนแขก",
  noOfNights: "จำนวนคืน",
  noProductsAvailable: "ไม่มีผลิตภัณฑ์ให้บริการ",
  noProductsSelected: "ยังไม่ได้เลือกผลิตภัณฑ์",
  noRecordsOf: "ไม่มีบันทึกของ",
  noRemainingBalance: "ไม่มียอดเงินคงเหลือ",
  noReportsFound: "ไม่พบรายงาน",
  noResultInSearch: "เราไม่พบผลลัพธ์ใด ๆ สำหรับการค้นหาของคุณ",
  noResults: "ไม่มีผลลัพธ์",
  noResultsFound: "ไม่พบผลลัพธ์",
  noResultsMatching: "ไม่มีผลลัพธ์ที่ตรงกัน",
  noResultsMatchingX: "ไม่มีผลลัพธ์ที่ตรงกับ “{0}”",
  noReturnCreditsInDateRange: "ไม่มีเครดิตคืนในช่วงวันที่นี้",
  noSalesInDateRange: "ไม่มีการขายในช่วงวันที่นี้",
  noSearchResultsForName: "ไม่มีผลการค้นหาสำหรับ {0}",
  noStocks: "ไม่มีสต๊อก",
  noTagUid: "ไม่มีแท็ก UID",
  noTagsFound: "ไม่พบแท็ก",
  noVoucherAvailable: "ไม่มีคูปองให้บริการ",
  noVoucherMovement: "ไม่มีการใช้คูปอง",
  noVouchersSelectedYet: "ยังไม่ได้เลือกคูปอง",
  nonRefundable: "ไม่สามารถคืนเงินได้",
  notCheckedIn: "ไม่เช็คอิน",
  notSellingOnPos: "ไม่ได้ขายที่ POS",
  note: "หมายเหตุ",
  notePreviousTransaction: "หมายเหตุ: ธุรกรรมก่อนหน้าที่ทำกับผลิตภัณฑ์เหล่านี้จะถูกเก็บไว้",
  noteTransactionStaff: "หมายเหตุ: ธุรกรรมก่อนหน้าที่ทำกับพนักงานคนนี้จะถูกเก็บไว้",
  notedByOn: "หมายเหตุโดย {0} เมื่อ {1}",
  notes: "หมายเหตุ",
  notificationSettings: "การตั้งค่าการแจ้งเตือน",
  notifications: "การแจ้งเตือน",
  nthGuestWhoUseThisTag: "แขก {0} คนที่ใช้แท็กนี้",
  nthStaffWhoUsedThisTag: "พนักงาน {0} คนที่ใช้แท็กนี้",
  nthUse: "ใช้ {0} คน",
  numberOfGuests: "จำนวนแขก",
  numberOfNights: "จำนวนคืน",
  offline: "ออฟไลน์",
  ok: "ตกลง",
  okay: "ตกลง",
  onPos: "ที่ POS",
  onceYouBanATag:
    "เมื่อคุณปิดการใช้งานแท็กแล้ว แท็กนั้นจะไม่สามารถใช้เพื่อทำธุรกรรมภายในสถานที่ของคุณได้",
  onceYouCompleteStocktake:
    "เมื่อคุณตรวจนับสต็อคเรียบร้อยแล้ว ปริมาณของรายการวัตถุดิบทั้งหมดจะถูกปรับตามนั้น การดำเนินการนี้ไม่สามารถยกเลิกได้",
  open: "เปิด",
  openReceiptPreview: "ดูตัวอย่างใบเสร็จ",
  openWindow: "เปิดหน้าต่างสู่ตำแหน่ง",
  openingBalance: "ยอดยกมา",
  optionNameAlreadyExists: "มีชื่อตัวเลือกนี้แล้ว",
  options: "ตัวเลือก",
  orNo: "หรือ#",
  orderQty: "จำนวนสั่งซื้อ",
  original: "ต้นฉบับ",
  other: "อื่นๆ",
  others: "อื่นๆ",
  overview: "ภาพรวม",
  pairedTagOnCheckin: "แท็กคู่เมื่อเช็คอิน",
  pairedTags: "แท็กที่จับคู่",
  parLevel: "ระดับ Par",
  password: "รหัสผ่าน",
  passwordDoesNotMatch: "รหัสผ่านที่คุณป้อนไม่ตรงกัน",
  passwordIncorrect: "รหัสผ่านที่คุณป้อนไม่ถูกต้อง",
  passwordsDoNotMatch: "รหัสผ่านไม่ตรงกัน",
  paymentAndCreditSettings: '"การตั้งค่าการชำระเงินและเครดิต',
  paymentMethod: "วิธีการชำระเงิน",
  paymentMethodAddedName: 'เพิ่มวิธีการชำระเงิน "{0}" แล้ว',
  paymentMethodAlreadyExist: "มีวิธีการชำระเงินอยู่แล้ว",
  paymentMethodName: "ชื่อวิธีการชำระเงิน",
  paymentMethods: "วิธีการชำระเงิน",
  paymentMethodsDescription: "สร้างและจัดการวิธีการชำระเงินที่คุณยอมรับในสถานที่ของคุณ",
  paymentMethodsSettings: "การตั้งค่าวิธีการชำระเงิน",
  paymentMethodsYouAccept: "วิธีการชำระเงินที่คุณยอมรับในสถานที่ของคุณ",
  paymentStatus: "สถานะการชำระเงิน",
  perPage: "{0} ต่อหน้า",
  percentage: "เปอร์เซ็นต์",
  percentageBetween: "เปอร์เซ็นต์ควรอยู่ระหว่าง 1-100",
  permitNumberWithColonSymbol: "หมายเลขใบอนุญาต:",
  phone: "โทรศัพท์",
  pleaseCheckYourNetwork: "โปรดตรวจสอบเครือข่ายของคุณเพื่ออัปเดตข้อมูลสถานที่ของคุณ",
  pleaseConnectToAnAccounting: "โปรดเชื่อมต่อกับผสานบัญชีเพื่อจัดการผังบัญชีของคุณ",
  pleaseCreateLocation: "โปรดสร้างตำแหน่งอย่างน้อย 1 ตำแหน่งเพื่อจัดสรรสต็อคของรายการวัตถุดิบนี้",
  pleaseCreateYourChartOfAccounts:
    "โปรดสร้างผังบัญชีในการตั้งค่าหมวดหมู่บัญชีในแดชบอร์ด MEWS ของคุณ",
  pleaseEnsureLocation:
    "โปรดตรวจสอบให้แน่ใจว่าตำแหน่งไม่มีธุรกรรมที่กำลังดำเนินการก่อนที่จะเริ่มตรวจนับสต๊อก",
  pleaseSelectLocation: "กรุณาเลือกตำแหน่ง",
  pleaseSelectStockUnit: "กรุณาเลือกหน่วยสต๊อก",
  pointOfSale: "จุดขาย",
  posDevices: "อุปกรณ์ ณ จุดขาย",
  posProvider: "ผู้ให้บริการ POS",
  postPaidCreditsIsTheAmount:
    "เครดิตแบบชำระภายหลังคือจำนวนเงินที่แขกสามารถใช้ได้เมื่อยอดเงินคงเหลือเป็นศูนย์ เมื่อแขกมียอดเครดิตคงค้างชำระภายหลัง จำนวนเงินควรจะชำระและชำระผ่านการเติมเงินหรือเมื่อเช็คเอ้าท์",
  postPaidCreditsUsed: "เครดิตแบบชำระภายหลังที่ใช้",
  postpaidCreditLimit: "วงเงินเครดิตแบบชำระภายหลัง",
  postpaidCredits: "เครดิตแบบชำระภายหลัง",
  postpaidCreditsLiabilityAccount: "บัญชีรับผิดเครดิตแบบชำระภายหลัง",
  postpaidCreditsLiabilityAccountMessage:
    "เครดิตที่ใช้เมื่อแขกมียอดคงเหลือเป็นศูนย์ ต้องชำระเงินด้วยการเติมเงินเมื่อเช็คเอาท์",
  postpaidCreditsLiabilityAccountPlaceholder: "[xxxx] - สินทรัพย์/เครดิตแบบชำระภายหลัง",
  postpaidCreditsUsed: "เครดิตแบบชำระภายหลังที่ใช้",
  postpaidCreditsUsedCanOnlyBeReplenished:
    '"เครดิตแบบชำระภายหลังที่ใช้สามารถเติมและชำระเงินผ่านการเติมเงินหรือเมื่อเช็คเอาท์เท่านั้น',
  pouchConnect: "PouchCONNECT",
  pouchLogo: "โลโก้ PouchNATION",
  pouchnation: "PouchNATION",
  powerYourVenue: "เพิ่มประสิทธิภาพให้แก่สถานที่ของคุณด้วยการผสานรวม",
  preloadedVouchers: "คูปองที่โหลดไว้ล่วงหน้า",
  preparingReport: "จัดทำรายงาน",
  previousBalance: "ยอดคงเหลือก่อนหน้า",
  price: "ราคา",
  pricePerOrderQty: "ราคาต่อจำนวนการสั่งซื้อ",
  pricing: "ราคา",
  pricingAndTaxes: "ราคาและภาษี",
  printableItems: "รายการที่พิมพ์ได้",
  printableItemsSelect: "เลือกผลิตภัณฑ์ที่จะพิมพ์บนโปรไฟล์เครื่องพิมพ์นี้",
  printerLocationsDesc: "เลือกตำแหน่งที่สามารถใช้โปรไฟล์เครื่องพิมพ์นี้ได้",
  printerProfile: "โปรไฟล์เครื่องพิมพ์",
  printerProfileCreated: "สร้างโปรไฟล์เครื่องพิมพ์ “{0}” แล้ว",
  printerProfileDeleted: "โปรไฟล์เครื่องพิมพ์ถูกลบ",
  printerProfileName: "ชื่อโปรไฟล์เครื่องพิมพ์",
  printerProfileNameAlreadyExists: "มีชื่อโปรไฟล์เครื่องพิมพ์นี้แล้ว",
  printerProfileUpdated: "อัปเดตโปรไฟล์เครื่องพิมพ์ “{0}” แล้ว",
  printerProfiles: "โปรไฟล์เครื่องพิมพ์",
  printers: "เครื่องพิมพ์",
  prioritizedAndUsedFirst: "จัดลำดับความสำคัญและใช้ก่อนเมื่อชำระเงิน",
  privacy: "ความเป็นส่วนตัว",
  privacyPolicy: "นโยบายความเป็นส่วนตัว",
  privacyPolicy2: "นโยบายความเป็นส่วนตัว",
  proceed: "ดำเนินการ",
  proceedToCheckout: "ดำเนินการชำระเงิน",
  processingTransactions: "กำลังดำเนินการธุรกรรม...",
  product: "ผลิตภัณฑ์",
  productCategories: "หมวดหมู่ผลิตภัณฑ์",
  productCategory: "ประเภทผลิตภัณฑ์",
  productCount: "จำนวนผลิตภัณฑ์",
  productDeleted: 'ลบผลิตภัณฑ์ "{0}" แล้ว',
  productList: "รายการผลิตภัณฑ์",
  productName: "ชื่อผลิตภัณฑ์",
  productRedeemed: "แลกรับผลิตภัณฑ์",
  productRemovedFromInventory: "{0} ผลิตภัณฑ์ถูกลบออกจากสินค้าคงคลัง",
  productSet: "ชุดผลิตภัณฑ์",
  productSetDeleted: 'ลบชุดผลิตภัณฑ์ "{0}" แล้ว',
  productSetName: "ชื่อชุดผลิตภัณฑ์",
  productUpdated: "อัปเดตผลิตภัณฑ์ {0} รายการ",
  products: "ผลิตภัณฑ์",
  productsArePartOfComposite:
    "ผลิตภัณฑ์เหล่านี้เป็นส่วนประกอบของผลิตภัณฑ์อื่นๆ หากต้องการลบ ให้ลบออกจากผลิตภัณฑ์ส่วนประกอบก่อน หรือลบออก {0} ด้วยผลิตภัณฑ์คอมโพสิตที่มีอยู่",
  productsAreSupplyItemsAre:
    "{0} คือผลิตภัณฑ์ที่คุณขายในสถานที่ของคุณ {1} คือรายการที่คุณใช้เพื่อประกอบผลิตภัณฑ์ของคุณ รายการซัพพลายได้รับการจัดการใน {2} ของคุณ",
  productsCanBeRedeemed: "เลือกผลิตภัณฑ์จากสินค้าคงคลังของคุณที่สามารถแลกได้จากคูปองนี้",
  productsDeleted: "ลบผลิตภัณฑ์ {0} รายการ",
  productsDoesNotExist: "ผลิตภัณฑ์ที่คุณต้องการเพิ่มต้องมีอยู่ในทุกตำแหน่ง",
  productsForDeletion:
    "ผลิตภัณฑ์ {0} รายการที่มีตำแหน่งนี้พร้อมสำหรับการลบเช่นกัน การดำเนินการนี้ไม่สามารถยกเลิกได้",
  productsRemovedFromInventory: "{0} ผลิตภัณฑ์ถูกลบออกจากผลิตภัณฑ์คงคลัง",
  productsToBeDeleted: "ผลิตภัณฑ์ที่จะลบ",
  productsUpdated: "อัปเดตผลิตภัณฑ์ {0} รายการ",
  productsVSupplyItems: "ผลิตภัณฑ์เทียบกับรายการวัตถุดิบ",
  productsVariants: "ผลิตภัณฑ์ / ตัวเลือก",
  profile: "โปรไฟล์",
  profileName: "ชื่อโปรไฟล์",
  profileNameAlreadyExists: "ชื่อโปรไฟล์มีอยู่แล้ว โปรดป้อนชื่ออื่น",
  propertyManagementSystem: "ระบบบริหารจัดการทรัพย์สิน",
  purchasingAndInventory: "การจัดซื้อและสินค้าคงคลัง",
  qty: "จำนวน",
  quantity: "ปริมาณ",
  quantitySupplyItems: "ปริมาณของรายการวัตถุดิบที่ใช้สำหรับผลิตภัณฑ์นี้",
  question: "คำถาม",
  questionAddedName: "เพิ่มคำถาม “{0}“ แล้ว",
  questionAlreadyExist: "มีคำถามอยู่แล้ว",
  questionDeleted: "ลบคำถาม “{0}“ แล้ว",
  questionDescription:
    "ข้อมูลที่จะรวบรวมเมื่อแขกลงทะเบียน ใช้คำถามเหล่านี้โดยกำหนดให้กับ {0} ของคุณ",
  questionSettings: "การตั้งค่าคำถาม",
  questions: "คำถาม",
  radioButton: "ปุ่มตัวเลือก",
  reachedReorderPoint: "ถึงจุดสั่งซื้อใหม่",
  reallyUnbanTag: "เลิกปิดใช้งานแท็กนี้จริงหรอ?",
  reallyUnbanThisTagDescription:
    "การเลิกปิดใช้งานแท็กนี้จะมีผลในครั้งถัดไปที่อุปกรณ์ของคุณได้รับการซิงค์และอัปเดต (โดยปกติทุกๆ 5 นาทีเมื่อเชื่อมต่ออินเทอร์เน็ต) เพื่อให้สอดคล้องกับการเปลี่ยนแปลงเหล่านี้ทันที โปรดซิงค์และอัปเดตอุปกรณ์ของคุณเมื่อคุณเลิกปิดใช้งานแท็กนี้",
  reason: "เหตุผล",
  reasonsForStay: "เหตุผลในการเข้าพัก",
  receiptFormatting: "การจัดรูปแบบใบเสร็จ",
  receiptNumber: "เลขที่ใบเสร็จ",
  receiptSettings: "การตั้งค่าใบเสร็จรับเงิน",
  receipts: "ใบเสร็จ",
  recentTransactions: "ธุรกรรมล่าสุด",
  reconnect: "เชื่อมต่อใหม่",
  redeem: "แลก",
  redeemableProducts: "ผลิตภัณฑ์แลกซื้อ",
  redeemed: "แลกแล้ว",
  refreshingThisPage: "กำลังรีเฟรชหน้านี้",
  refundedCredits: "เครดิตเงินคืน",
  registerGuests: "ลงทะเบียนแขก",
  registerInfo: "ลงทะเบียนข้อมูล",
  registerReports: "ลงทะเบียนรายงาน",
  registerReportsPage: "หน้ารายงานการลงทะเบียน",
  registerStaff: "ลงทะเบียนเจ้าหน้าที่",
  remove: "ลบ",
  removeFreeCredits: "ลบเครดิตฟรี",
  removeFromList: "ลบออกจากรายการ",
  removeNameAsYourStaff: "ลบ {0} ในฐานะพนักงานของคุณหรือไม่?",
  removeStocks: "ลบสต๊อก?",
  removeStocksConfirm: "ลบสต๊อก",
  removeStocksDetails: "คุณแน่ใจหรือไม่ว่าต้องการลบ {0} {1} ในสต๊อกของ {2} ใน {3}?",
  removeThisAccount: "นำบัญชีนี้ออกไหม?",
  removeThisSupplyItem: "ลบรายการวัตถุดิบนี้ออกจากผลิตภัณฑ์ก่อนเพื่อลบรายการนี้",
  removeVariant: "ลบตัวเลือก",
  removeVariantFirstFromProduct: "ลบตัวเลือกผลิตภัณฑ์นี้ออกจากผลิตภัณฑ์ก่อน",
  removedStock: "ลบสต๊อก",
  reorderPoint: "จุดสั่งซื้อใหม่",
  reorderPointReached: "ถึงจุดสั่งซื้อใหม่แล้ว",
  reorderStocks: "สั่งสต๊อกใหม่",
  reports: "รายงาน",
  reportsFailedToLoad: "ไม่สามารถโหลดรายงาน",
  reportsInfoPage: "หน้าข้อมูลรายงาน",
  requireManagerAuthorization: "จำเป็นต้องมีการยืนยันจากผู้จัดการเมื่ออ้างสิทธิ์ส่วนลดนี้",
  required: "ที่จำเป็น",
  resendInvite: "ส่งคำเชิญอีกครั้ง?",
  resetExpiration: "รีเซ็ตวันหมดอายุ",
  resetTheExpirationPeriod: "รีเซ็ตระยะเวลาหมดอายุเมื่อแขกทำธุรกรรมเสร็จสิ้นโดยไม่ต้องเช็คอิน",
  restrictUseOfTags: "จำกัดการใช้แท็กบางอันในสถานที่ของคุณ",
  retailPrice: "ราคาขายปลีก",
  retailPriceMustNotBeNegative: "ราคาขายปลีกต้องไม่ติดลบ",
  retryReloadingChart: "ลองโหลดแผนภูมิอีกครั้ง",
  returnCredits: "คืนเครดิต",
  returnedTags: "แท็กที่ส่งคืน",
  returnedVoucher: "คูปองที่ส่งคืน",
  returningGuests: "แขกที่กลับมา",
  revenue: "รายรับ",
  revenueAccount: "บัญชีรายรับ",
  revenueAccountPlaceholder: "[xxxx] - รายได้/การขาย FOC",
  reviewYourDailyVenueActivity: "ตรวจสอบกิจกรรมสถานที่ประจำวันของคุณ",
  revokeInvite: "เพิกถอนคำเชิญ",
  revokeThisInvite: "เพิกถอนคำเชิญนี้หรือไม่",
  roadMap: "แผนงาน",
  role: "หน้าที่่",
  roleAndDesignation: "หน้าที่และการกำหนด",
  roles: "หน้าที่",
  rooms: "ห้อง",
  runEndOfDay: "ดำเนินการประจำวัน",
  sale: "ขาย",
  saleDiscounts: "รายได้/ส่วนลดการขาย",
  saleFoc: "รายได้/การขาย FOC",
  saleReturn: "ผลตอบแทนจากการขาย",
  sales: "ฝ่ายขาย",
  salesDiscounts: "ส่วนลดการขาย",
  salesDiscountsMessage: "ค่าใช้จ่ายสำหรับส่วนลดที่ใช้ทั้งหมด",
  salesDiscountsPlaceholder: "[xxxx] - ส่วนลดการขาย",
  salesFOCPlaceholder: "[xxxx] - รายได้/การขาย FOC",
  salesInformation: "ข้อมูลการขาย",
  salesReport: "รายงานการขาย",
  save: "บันทึก",
  saveAccountSetting: "บันทึกการตั้งค่าบัญชี",
  saveCategoryForm: "บันทึกแบบฟอร์มหมวดหมู่",
  saveCreditSetting: "บันทึกการตั้งค่าเครดิต",
  saveDeviceForm: "บันทึกแบบฟอร์มอุปกรณ์",
  saveDiscountForm: "บันทึกแบบฟอร์มส่วนลด",
  saveGeneralSettings: "บันทึกการตั้งค่าทั่วไป",
  saveLocationForm: "บันทึกแบบฟอร์มตำแหน่ง",
  saveNewSupplyItemForm: "บันทึกแบบฟอร์มรายการวัตถุดิบใหม่",
  savePaymentMethod: "บันทึกวิธีการชำระเงิน",
  savePrinterProfileForm: "บันทึกแบบฟอร์มโปรไฟล์เครื่องพิมพ์",
  saveProduct: "บันทึกผลิตภัณฑ์",
  saveProductSet: "บันทึกชุดผลิตภัณฑ์",
  saveQuestion: "บันทึกคำถาม",
  saveReceiptSettings: "บันทึกการตั้งค่าใบเสร็จ",
  saveStaffForm: "บันทึกแบบฟอร์มพนักงาน",
  saveStaffProfileForm: "บันทึกแบบฟอร์มประวัติพนักงาน",
  saveTaxSetting: "บันทึกการตั้งค่าภาษี",
  saveVenueForm: "บันทึกแบบฟอร์มสถานที่",
  saveVoucherForm: "บันทึกแบบฟอร์มคูปอง",
  saveWristbandKeepingSettings: "บันทึกการตั้งค่าการเก็บสายรัดข้อมือ",
  savedChanges: "การเปลี่ยนแปลงที่บันทึกไว้",
  search: "ค้นหา",
  searchBanTags: "ค้นหาแท็กที่ถูกปิดใช้งานโดยแท็ก UID",
  searchForProducts: "ค้นหาผลิตภัณฑ์หรือรายการวัตถุดิบ",
  searchForStockId: "ค้นหารหัสสต๊อก...",
  searchForStocktakeId: "ค้นหารหัสสินค้าคงคลัง...",
  searchGuestsByNameOrId: "ค้นหาแขกด้วยชื่อหรือแท็ก ID",
  searchMovementPlaceholder: "ค้นหาการใช้งานด้วยชื่อคูปอง ขื่ออุปกรณ์ ชื่อแขก",
  searchProductByKeyOrSku: "ค้นหาผลิตภัณฑ์ด้วยคีย์เวิร์ดหรือ SKU",
  searchProductsByKeyword: "ค้นหาผลิตภัณฑ์ตามคีย์เวิร์ด",
  searchProductsIn: "ค้นหาผลิตภัณฑ์ใน {0}",
  searchReportsByShiftId: "ค้นหารายงานตามรหัสกะ",
  searchResult: "ผลการค้นหา",
  searchResults: "ผลการค้นหา",
  searchSupplyItemBy: "ค้นหารายการซัพพลายตามชื่อหรือ SKU",
  searchTag: "ค้นหาแท็ก",
  searchTransactionPlaceholder: "ค้นหาธุรกรรมตามชื่อผู้เข้าพัก รหัสแท็ก ตำแหน่ง รหัสเช็คอิน",
  searchVouchers: "ค้นหาคูปอง",
  search2: "ค้นหา...",
  second: "วินาที",
  seconds: "วินาที",
  selectAType: "เลือกประเภท",
  selectAccount: "เลือกบัญชี",
  selectAccountPlaceholder: "เลือกบัญชี...",
  selectAccountType: "เลือกประเภทบัญชี",
  selectAndMakeComposition: "เลือกยี่ห้อและองค์ประกอบของผลิตภัณฑ์นี้",
  selectCategoriesOrProducts: "เลือกหมวดหมู่หรือผลิตภัณฑ์จากตำแหน่งที่คุณเลือก",
  selectCategory: "เลือกหมวดหมู่",
  selectDevice: "เลือกอุปกรณ์",
  selectGuestProfile: "เลือกโปรไฟล์แขก",
  selectItemsThisProductMadeOf:
    '"เลือกรายการที่ผลิตภัณฑ์นี้ทำจาก กำหนดปริมาณของการจัดหาผลิตภัณฑ์แต่ละรายการที่จะหักตามใบสั่งขายของผลิตภัณฑ์นี้',
  selectLocation: "เลือกตำแหน่ง",
  selectProducts: "เลือกผลิตภัณฑ์",
  selectStaff: "เลือกพนักงาน",
  selectStatus: "เลือกสถานะ",
  selectStockLevel: "เลือกระดับสต๊อก",
  selectStockUnit: "เลือกหน่วยสต๊อก",
  selectSupplyItem: "เลือกรายการวัตถุดิบ",
  selectTax: "เลือกภาษี",
  selectToIncludeCategory: "เลือกรวมผลิตภัณฑ์นี้ในหมวดหมู่..",
  selectToIncludeProductSetInCategory: "เลือกรวมผลิตภัณฑ์ชุดนี้เข้าหมวดหมู่..",
  selectVenue: "เลือกสถานที่",
  selectVouchers: "เลือกคูปอง",
  sellOnPos: "ขายที่ POS",
  selling: "ขาย",
  sellingOnPos: "ขายที่ POS",
  sellingQty: "จำนวนขาย",
  serialNumber: "หมายเลขซีเรียล",
  serialNumberAbbv: "S/N",
  set: "ชุด",
  setAnAmountToLimitPostPaid: "กำหนดจำนวนเงินเพื่อจำกัดเครดิตแบบชำระภายหลังของผู้เข้าพัก",
  setAsDefaultTax: "กำหนดให้เป็นภาษีเริ่มต้น",
  setAsNonRefundable: "กำหนดให้ไม่สามารถคืนเงินได้",
  setCode: "ตั้งรหัส",
  setExpirationPeriod: "กำหนดระยะเวลาหมดอายุ",
  setUpYourAccount: "ตั้งค่าบัญชีของคุณ!",
  sets: "ชุด",
  settings: "การตั้งค่า",
  share: "แบ่งปัน",
  shareThisLink: "แชร์ลิงก์นี้เพื่อเปิด {0} บนอุปกรณ์ใดก็ได้! คัดลอกลิงก์และแชร์กับพนักงานของคุณ",
  shift: "กะ",
  shiftEnd: "กะสิ้นสุด",
  shiftId: "รหัสกะ",
  shiftStart: "กะเริ่ม",
  shifts: "กะ",
  shouldBeANumber: "ต้องเป็นตัวเลข",
  show: "แสดง",
  showHideColumns: "แสดง / ซ่อนคอลัมน์",
  showLess: "แสดงน้อยลง",
  showMore: "แสดงมากขึ้น",
  signIn: "เข้าสู่ระบบ",
  signInButton: "ปุ่มลงชื่อเข้าใช้",
  signUp: "ลงชื่อ",
  sku: "SKU",
  skuAlreadyExists: "SKU มีอยู่แล้ว",
  skuStockKeepingUnit: "SKU (หน่วยในการจัดเก็บสินค้า)",
  someArePartOfCompositeNote:
    "{0} {1} ด้านล่างไม่สามารถลบได้เนื่องจากเป็นส่วนหนึ่งของผลิตภัณฑ์อื่นๆ หากต้องการลบรายการเหล่านี้ ให้ลบออกจากรายการผลิตภัณฑ์หรือลบ {2} ด้วยกรายการผลิตภัณฑ์ที่มีอยู่",
  somethingWentWrong: "อะไรบางอย่างผิดปกติ",
  spend: "ใช้จ่าย",
  staff: "พนักงาน",
  staffCanAccess: "พนักงานสามารถเข้าถึงแอป POS และดำเนินการได้",
  staffList: "รายชื่อพนักงาน",
  staffName: "ชื่อพนักงาน",
  staffNameAndOrTagId: "ชื่อพนักงานและ/หรือรหัสแท็ก",
  staffProfile: "โปรไฟล์พนักงาน",
  staffProfileDeleted: "โปรไฟล์พนักงานถูกลบ",
  staffProfileList: "รายชื่อโปรไฟล์พนักงาน",
  staffProfileName: "ชื่อโปรไฟล์พนักงาน",
  staffProfileNameCreated: "สร้างโปรไฟล์พนักงาน “{0}” แล้ว",
  staffProfileNamePlaceholder: "พิมพ์ชื่อโปรไฟล์พนักงานนี้...",
  staffProfiles: "โปรไฟล์พนักงาน",
  staffRemoved: "พนักงานถูกลบออก",
  staffTagWithColonSymbol: "แท็กพนักงาน:",
  staffWithColonSymbol: "พนักงาน:",
  standard: "มาตรฐาน",
  start: "เริ่ม",
  startStocktake: "เริ่มนับสต๊อก",
  startedOn: "เริ่มเมื่อ",
  status: "สถานะ",
  staying: "พักอยู่",
  stockBelowParLevel: "สต๊อกอยู่ต่ำกว่าระดับพาร์",
  stockLevelAlerts: "การแจ้งเตือนระดับสต๊อก",
  stockLevelNotificationSettings: "การตั้งค่าการแจ้งเตือนระดับสต๊อก",
  stockLevels: "ระดับสต๊อก",
  stockManager: "ผู้จัดการสต๊อก",
  stockReachedReorderPoint: "สต๊อกมาถึงจุดสั่งซื้อใหม่แล้ว",
  stockUnit: "หน่วยสต๊อก",
  stockVariance: "ตัวเลือกสต๊อก",
  stockWeightPerN: "น้ำหนักสต๊อกต่อ {0}",
  stocks: "สต๊อก",
  stocktake: "ตรวจนับสต๊อก",
  stocktakeAlreadyExists: "มีสต๊อกอยู่แล้ว",
  stocktakeSaved: "บันทึกสต๊อกแล้ว",
  stocktakeWithId: "ตรวจนับสต๊อก #ST-{0}",
  streetVillage: "ที่อยู่ ตำบล / หมู่บ้าน",
  subTotal: "ยอดรวม",
  subscribeAndRegister: "สมัครสมาชิกและลงทะเบียนตอนนี้เพื่อรับ",
  subscription: "สมัครสมาชิก",
  success: "ความสำเร็จ",
  sugar: "น้ำตาล",
  suggested: "แนะนำ",
  summary: "สรุป",
  supplyCost: "ต้นทุนการจัดหา",
  supplyItem: "รายการวัตถุดิบ",
  supplyItemAlreadyExists: "มีชื่อรายการวัตถุดิบแล้ว",
  supplyItemDeleted: "ลบรายการวัตถุดิบแล้ว",
  supplyItemNameCreated: "สร้างรายการวัตถุดิบ “{0}” แล้ว",
  supplyItemSummaryPage: "หน้าสรุปรายการวัตถุดิบ",
  supplyItems: "รายการวัตถุดิบ",
  supplyUnit: "หน่วยวัตถุดิบ",
  syncToMews: "ซิงค์กับ MEWS",
  tagBanned: "แท็กที่ปิดใช้งาน",
  tagId: "หมายเลขแท็ก",
  tagIds: "หมายเลขแท็ก",
  tagInfo: "ข้อมูลแท็ก",
  tagUID: "แท็ก UID",
  tagUnbanned: "เลิกปิดการใช้งานแท็กแล้ว",
  tags: "แท็ก",
  tagsIssued: "แท็กออก",
  tapCount: "แตะนับ",
  tapStatus: "แตะสถานะ",
  tax: "ภาษี",
  taxAddedName: 'เพิ่มภาษี "{0}" แล้ว',
  taxAlreadyExists: "มีภาษีอยู่แล้ว",
  taxEditNote:
    "หมายเหตุ: ผลิตภัณฑ์ที่เชื่อมโยงกับภาษีนี้จะได้รับการอัปเดตโดยอัตโนมัติ ซึ่งจะไม่ส่งผลกระทบต่อยอดขายที่ผ่านมา",
  taxEg: "เช่น “ภาษีมูลค่าเพิ่ม”",
  taxIncluded: "รวมภาษี",
  taxName: "ชื่อผู้เสียภาษี",
  taxNumber: "หมายเลขภาษี",
  taxOnPurchasesAccount: "ภาษีในบัญชีซื้อ",
  taxOnPurchasesAccountMessage: "ภาษีมูลค่าเพิ่มและภาษีอื่นๆ ในใบสั่งซื้อ",
  taxOnPurchasesAccountPlaceholder: "[xxxx] - ความรับผิด/ภาษีในการซื้อ",
  taxOnSalesLiabilityAccount: "ภาษีในบัญชีความรับผิดในการขาย",
  taxOnSalesLiabilityAccountMessage: "บัญชีเริ่มต้นสำหรับภาษีที่เรียกเก็บสำหรับแต่ละผลิตภัณฑ์",
  taxOnSalesLiabilityAccountPlaceholder: "[xxxx] - ความรับผิด/ภาษีจากการขาย",
  taxPercentageAndValue: "ภาษี ({0}%): {1}",
  taxRate: "อัตราภาษี",
  taxSettings: "การตั้งค่าภาษี",
  taxes: "ภาษี",
  termsAndConditions: "ข้อกำหนดและเงื่อนไข",
  termsInAllowingAccess:
    "การคลิกที่อนุญาตการเข้าถึง แสดงว่าคุณอนุญาตให้ {0} ใช้ รับ และจัดเก็บข้อมูลของคุณ โปรดตรวจสอบ {2} และ {3} ของ {1} คุณสามารถหยุดการตั้งค่าการผสานรวมของบัญชี PouchNATION ได้ทุกเมื่อ",
  termsInSignUp: "การลงทะเบียนแสดงว่า ฉันยอมรับ {0} {1} และ {2} ของ PouchNATION",
  termsOfService: "เงื่อนไขการให้บริการ",
  termsOfUse: "เงื่อนไขการใช้บริการ",
  textbox: "กล่องข้อความ",
  theLinkYouAreTryingToAccess: "ลิงก์ที่คุณพยายามเข้าถึงไม่ได้มาจากสถานที่ของคุณ",
  theLinkYouAreTryingToAccessDoesNotBelongToLocation:
    "ลิงก์ที่คุณพยายามเข้าถึงไม่ได้มาจากตำแหน่งที่คุณกำหนด",
  theShiftAndTransactionDetails:
    "รายละเอียดกะและธุรกรรมจะแสดงที่นี่เมื่อกะถูกปิดในเครื่องบันทึกเงินสด",
  thereIsSomeError:
    "ไม่นะ! มีข้อผิดพลาดบางอย่างที่เกิดจากเรา โปรดรอสักครู่และตรวจสอบอีกครั้งในภายหลัง",
  thereNthOtherProducts:
    "{0} {1} ผลิตภัณฑ์อื่นๆ ที่มีตำแหน่งนี้และตำแหน่งอื่นๆ จะยังคงอยู่ในสินค้าคงคลังของคุณ",
  theseProductsCannotBeDeleted: "ผลิตภัณฑ์เหล่านี้ไม่สามารถลบได้",
  thisAppRequests: "แอปนี้ขอข้อมูลต่อไปนี้:",
  thisAppWouldRead: "แอปนี้จะอ่านและ/หรือเขียนข้อมูลต่อไปนี้:",
  thisEmailIsAlreadyAdded: "เพิ่มอีเมลนี้แล้ว",
  thisEmailIsInvalid: "อีเมลนี้ไม่ถูกต้อง",
  thisFieldIsRequired: "จำเป็นต้องระบุ",
  thisMonth: "เดือนนี้",
  thisProductNameAlreadyExists: "มีชื่อผลิตภัณฑ์นี้แล้ว",
  thisProductsHasMultipleVariant: "ผลิตภัณฑ์มีหลายแบบให้เลือก เช่น ขนาด สี รส ฯลฯ",
  thisQuestionIsLinkedToNProfiles: "คำถามนี้เชื่อมโยงกับโปรไฟล์แขก {0} รายการ",
  thisServesAsAnOfficialReceipt: "- ใช้เป็นใบเสร็จรับเงินอย่างเป็นทางการ -",
  thisSkuExists: "มี SKU นี้แล้ว",
  thisStaffHasNpLongerAccess:
    "พนักงานนี้จะไม่สามารถเข้าถึง {0} ได้อีกต่อไป การดำเนินการนี้ไม่สามารถยกเลิกได้",
  thisTagIdIsAlreadyBanned: "ID แท็กนี้ถูกปิดใช้งานแล้ว",
  thisVenueFreeTrial: "สถานที่นี้จะเปิดให้ทดลองใช้งานฟรีใน 30 วันแรก",
  thisWeek: "ในสัปดาห์นี้",
  time: "เวลา",
  timeEnded: "ช่วงเวลา",
  timeRange: "เวลาสิ้นสุด",
  timeStarted: "เวลาเริ่มต้น",
  to: "ถึง",
  toAddMoreCreditsToATag: "หากต้องการเพิ่มเครดิตให้กับแท็ก แขกอาจสามารถ",
  toBeCheckedIn: "ที่จะเช็คอิน",
  toBeCheckedOut: "ที่จะเช็คเอาท์",
  toContinueCreatingDiscount: "หากต้องการสร้างส่วนลดนี้ต่อ คุณต้องสร้างตำแหน่งก่อน",
  toContinueCreatingProducts: "หากต้องการสร้างผลิตภัณฑ์นี้ต่อ คุณต้องสร้างตำแหน่งก่อน",
  toContinueCreatingStaff: "หากต้องการสร้างพนักงานคนนี้ต่อ คุณต้องสร้างตำแหน่งก่อน",
  toContinueCreatingStocktake: "หากต้องการสร้างสต๊อกนี้ต่อ คุณต้องสร้างตำแหน่งก่อน",
  toDeleteItem: "เพื่อลบรายการนี้",
  today: "วันนี้",
  together: "ด้วยกัน",
  topCategoriesBySales: "หมวดหมู่ยอดนิยมตามฝ่ายขาย",
  topLocations: "ตำแหน่งยอดนิยม",
  topProducts: "ผลิตภัณฑ์ยอดนิยม",
  topSpendingGuests: "แขกผู้มียอดใช้จ่ายสูงสุด",
  topupAndReturnCredits: "เติมและคืนเครดิต",
  topupCredits: "เติมเงินเครดิต",
  total: "รวม",
  totalAmount: "จำนวนเงินทั้งหมด",
  totalBookings: "ยอดจอง",
  totalFreeCreditsIssued: "เครดิตฟรีทั้งหมดที่ออก",
  totalFreeCreditsRemoved: "ลบเครดิตฟรีทั้งหมด",
  totalInStock: "รวมในสต๊อก",
  totalPaid: "ทั้งหมดที่จ่าย",
  totalProductSales: "ยอดขายผลิตภัณฑ์ทั้งหมด",
  totalRefundedCredits: "เครดิตเงินคืนทั้งหมด",
  totalRemoved: "ลบทั้งหมด",
  totalReturnCredits: "เครดิตคืนทั้งหมด",
  totalReturnedCredits: "เครดิตเงินคืนทั้งหมด",
  totalSales: "ยอดขายทั้งหมด",
  totalSpent: "ยอดใช้จ่ายทั้งหมด",
  totalSpentToDate: "ยอดใช้จ่ายทั้งหมดจนถึงปัจจุบัน",
  totalStocksPerLocation: "จำนวนสต็อคทั้งหมดต่อตำแหน่ง",
  totalTagsUsed: "แท็กที่ออกทั้งหมด",
  totalTax: "ภาษีทั้งหมด",
  totalTopUps: "เติมเงินทั้งหมด",
  totalTopupCredits: "เครดิตเติมเงินทั้งหมด",
  totalTransactions: "รวมธุรกรรม",
  totalUse: "การใช้งานทั้งหมด",
  totalVisits: "การเข้าชมทั้งหมด {0}",
  totals: "ยอดรวม",
  trackAndManage: "ติดตามและจัดการการนับสินค้าคงคลังด้วยคุณ",
  trackEveryGuestCheckedIn:
    "ติดตามแขกทุกคนที่เช็คอินในตำแหน่งของคุณ พร้อมดูผลิตภัณฑ์และตำแหน่งโปรดของพวกเขา",
  trackWhichItemsLow: "ติดตามดูว่ามีสินค้าใดในสต๊อกที่ต่ำและจำเป็นต้องจัดหาใหม่",
  trackedInventory: "ติดตามสินค้าคงคลัง",
  transaction: "ธุรกรรม",
  transactionId: "รหัสธุรกรรม",
  transactionInfoPage: "หน้าข้อมูลการทำธุรกรรม",
  transactionStatus: "สถานะการทำธุรกรรม",
  transactionType: "ประเภทรายการ",
  transactions: "ธุรกรรม",
  transactionsFailedToProcess: "ธุรกรรมล้มเหลวในการประมวลผล",
  transactionsPage: "หน้าธุรกรรม",
  try: "ลอง:",
  turnOffPos: "ปิดการขาย {0} {1}?",
  turnOnPos: "เปิดการขาย {0} {1}?",
  txnId: "รหัส Txn: #",
  type: "พิมพ์",
  typeAQuestion: "พิมพ์คำถาม",
  typeAReason: "พิมพ์เหตุผล...",
  typeAnOption: "พิมพ์ตัวเลือก",
  typeDisconnect: "พิมพ์ DISCONNECT เป็นตัวพิมพ์ใหญ่เพื่อยืนยัน",
  typeHere: "พิมพ์ที่นี่...",
  typeToSearch: "พิมพ์เพื่อค้นหารายการ!",
  typeToSetAccountCode: "พิมพ์เพื่อตั้งค่า/เลือกรหัสบัญชี",
  unableToDelete: "ลบไม่ได้",
  unbaleToUploadMoreThanMb: "ไม่สามารถอัปโหลดเกิน 1mb",
  unban: "เลิกการปิดใช้งาน",
  unbanTag: "เลิกการปิดใช้งานแท็ก",
  unbanningWillMakeTagAccessible: "การเลิกปิดใช้งานแท็กจะทำให้แท็กนี้เข้าถึงได้ในสถานที่ของคุณ",
  uncategorized: "เลิกการจัดหมวดหมู่",
  undo: "เลิกทำ",
  unitSold: "หน่วยขาย",
  unitsSold: "หน่วยขาย",
  unknown: "ไม่รู้จัก",
  updatedOn: "อัปเดตเมื่อ {0}",
  uploadPhoto: "อัพโหลดรูปภาพ",
  uponRegistration: "เมื่อลงทะเบียนหรือกับเจ้าหน้าที่เติมเงิน / ตู้คีออสภายในสถานที่",
  usage: "การใช้งาน",
  usageDatePeriod: "ระยะเวลาวันที่ใช้งาน",
  useVenueAppAndLogin:
    "ใช้แอปสถานที่และเข้าสู่ระบบด้วยแท็ก NFC ที่เปิดใช้งานหรือด้วยชื่อผู้ใช้หรือรหัสผ่านปัจจุบันของคุณ ยังไม่มีแอป? ถามผู้จัดการสถานที่ของคุณหรือ {0}",
  used: "ใช้แล้ว",
  usesLastIssuedTo: "ใช้, ออกล่าสุดไปยัง",
  validUntilWithColonSymbol: "ใช้ได้ถึงวันที่;",
  value: "ค่า",
  valueBetween: "ค่าควรอยู่ระหว่าง",
  valueRedeemed: "มูลค่าที่แลก",
  variant: "ตัวเลือก",
  variantAlreadyExist: "มีตัวเลือกอยู่แล้ว",
  variantIsCurrentlyBeingUsed: "ปัจจุบันมีการใช้ตัวเลือกในผลิตภัณฑ์ต่อไปนี้",
  variants: "ตัวเลือก",
  vatReg: "ทะเบียนภาษีมูลค่าเพิ่ม",
  venueCurrency: "สกุลเงินของสถานที่",
  venueDashboard: "แดชบอร์ดสถานที่",
  venueDetails: "รายละเอียดสถานที่",
  venueLocation: "ที่ตั้งตำแหน่ง",
  venueName: "ชื่อสถานที่",
  venueNameAlreadyExist: "มีชื่อสถานที่อยู่แล้ว กรุณาเลือกชื่ออื่น",
  venueSettings: "การตั้งค่าสถานที่",
  view: "ดู",
  viewAllTransactions: "ดูธุรกรรมทั้งหมด",
  viewAndExportDiscountReport:
    "ดูและส่งออกรายการส่วนลดของคุณและยอดรวมที่หักสำหรับส่วนลดแต่ละรายการ",
  viewAndExportEachClosedRegister:
    "ดูและส่งออกรายงานการลงทะเบียนปิดแต่ละรายการที่ทำโดยพนักงานของคุณ",
  viewAndExportSalesReportByCategories: "ดูและส่งออกรายงานการขายของคุณตามหมวดหมู่",
  viewAndExportVoucherReport:
    "ดูและส่งออกคูปองทั้งหมดที่ใช้กับผลิตภัณฑ์ที่แลกและจำนวนรวมของการขายปลีกและวัตถุดิบที่แลกโดยคูปองแต่ละใบ",
  viewBillingStatement: "ดูใบแจ้งยอดการเรียกเก็บเงิน",
  viewBookingInfo: "ดูข้อมูลการจองจากแพลตฟอร์มต่างๆ เช่น MEWS, PouchNATION Ticketing และอีกมากมาย!",
  viewCategoryDetails: "ดูรายละเอียดหมวดหมู่",
  viewDetails: "ดูรายละเอียด",
  viewDevice: "ดูอุปกรณ์",
  viewDiscountDetails: "ดูรายละเอียดส่วนลด",
  viewEveryTransactions: "ดูทุกธุรกรรมที่ทำในสถานที่ของคุณภายในระยะเวลาหนึ่ง",
  viewIntegrations: "ดูการผสานรวม",
  viewNTransactions: "ดูธุรกรรม {0}",
  viewPlansAndPricing: "ดูแผนและราคา",
  viewPreview: "ดูตัวอย่าง",
  viewTaxSettings: "ดูการตั้งค่าภาษี",
  viewTheSalesSummaryOfYourVenue:
    "ดูข้อมูลสรุปการขายของสถานที่และตำแหน่ง ผลิตภัณฑ์ และอื่นๆ ที่ขายดี",
  viewVoucherDetails: "ดูรายละเอียดคูปอง",
  void: "ยกเลิก",
  voidAuthorization: "การอนุญาตยกเลิก",
  voidConfirmation: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิก {0} การดำเนินการนี้ไม่สามารถยกเลิกได้",
  voidId: "ยกเลิก {0}?",
  voidInfo: "ยกเลิกข้อมูล",
  voidReason: "สาเหตุการยกเลิก",
  voidStocktake: "ยกเลิกการนับสต๊อก",
  voided: "ยกเลิกแล้ว",
  voidedBy: "ยกเลิกโดย",
  voidedItems: "รายการที่ยกเลิก",
  voidedOn: "ยกเลิกเมื่อ",
  voidedValue: "มูลค่าที่ยกเลิก",
  voucher: "คูปอง",
  voucherApplied: "ใช้คูปอง",
  voucherAvailable: "คูปองนี้สามารถออกในสถานที่ของคุณได้",
  voucherCreated: "{0} เพิ่ม",
  voucherDeleted: "ลบคูปอง {0} แล้ว",
  voucherMovementPage: "หน้าการใช้งานคูปอง",
  voucherName: "ชื่อคูปอง",
  voucherNameAlreadyExist: "ชื่อคูปองนี้มีอยู่แล้ว",
  voucherReport: "รายงานคูปอง",
  voucherRetailValue: "คูปองมูลค่าขายปลีก",
  voucherSupplyValue: "มูลค่าการจัดหาคูปอง",
  voucherType: "ประเภทคูปอง",
  voucherUpdated: "อัพเดทคูปอง",
  vouchers: "คูปอง",
  vouchersCreationLimitInfo:
    "คุณสามารถสร้างคูปองได้สูงสุด 8 ใบต่อสถานที่ คุณสามารถลบคูปองที่หมดอายุหรือใช้งานไม่ได้เพื่อให้มีที่ว่างสำหรับคูปองเพิ่มเติม",
  vouchersIssued: "คูปองที่ออก",
  vouchersListPage: "หน้ารายการคูปอง",
  vouchersMaximumNumberReached: "คูปองถึงจำนวนสูงสุดแล้ว",
  vouchersRedeemed: "แลกคูปองแล้ว",
  vouchersRemoved: "คูปองถูกลบออก",
  vouchersUsage: "การใช้คูปอง",
  weDidNotFoundReports: "เราไม่พบรายงานใดๆ สำหรับตัวกรองของคุณ",
  weeksAfterCheckout: "สัปดาห์หลังเช็คเอาท์",
  weightInGrams: "น้ำหนักเป็นกรัม",
  welcomeBack: "ยินดีต้อนรับกลับ!",
  whenAnItemAlertLevel: "เมื่อรายการต่ำถึงระดับการแจ้งเตือน",
  whole: "ทั้งหมด",
  wholeProduct: "ผลิตภัณฑ์ทั้งหมด",
  withPendingPayments: "ด้วยการชำระเงินที่รอดำเนินการ",
  withRemainingBalance: "ด้วยยอดเงินคงเหลือ",
  wristbandKeeping: "การรักษาสายรัดข้อมือ",
  wristbandTag: "แท็กสายรัดข้อมือ",
  wristbandTagKeeping: "การเก็บรักษาแท็กสายรัดข้อมือ",
  wristbandTagSettings: "การตั้งค่าแท็กสายรัดข้อมือ",
  xConnectedFailed:
    "ดูเหมือนเราจะไม่รู้จักโทเค็นการเข้าถึงนี้ โปรดดูคำแนะนำด้านล่างเพื่อดึงโทเค็นการเข้าถึงที่เหมาะสมของคุณ",
  xConnectedSuccessfully: "{0} เชื่อมต่อสำเร็จแล้ว",
  year: "ปี",
  years: "ปีที่",
  yes: "ใช่",
  youAreAboutToDelete: 'คุณกำลังจะลบ {0} "{1}" การดำเนินการนี้ไม่สามารถยกเลิกได้',
  youAreAboutToDeleteAQuestionThatIsLinked:
    "คุณกำลังจะลบคำถามที่เชื่อมโยงกับโปรไฟล์ผู้เยี่ยมชม การดำเนินการนี้ไม่สามารถยกเลิกได้",
  youAreAboutToDeleteGuestProfile:
    "คุณกำลังจะลบโปรไฟล์ผู้เยี่ยมชมนี้ การดำเนินการนี้ไม่สามารถยกเลิกได้",
  youAreAboutToDeleteMultiple: "คุณกำลังจะลบ {0} {1} การดำเนินการนี้ไม่สามารถยกเลิกได้",
  youAreAboutToDeletePaymentMethod: 'คุณกำลังจะลบวิธีการชำระเงิน "{0}"',
  youAreAboutToDeleteQuestion: "คุณกำลังจะลบคำถามนี้ การดำเนินการนี้ไม่สามารถยกเลิกได้",
  youAreAboutToDeleteStaffName:
    "คุณกำลังจะลบ {0} ในฐานะพนักงานของคุณ พนักงานนี้จะไม่สามารถเข้าถึง {1} ได้อีกต่อไป การดำเนินการนี้ไม่สามารถยกเลิกได้",
  youAreAboutToDeleteStaffProfile:
    "คุณกำลังจะลบโปรไฟล์พนักงานนี้ การดำเนินการนี้ไม่สามารถยกเลิกได้",
  youAreAboutToDeleteTax: 'คุณกำลังจะลบภาษี "{0}"',
  youAreAboutToDisconnect: "คุณกำลังจะยกเลิกการเชื่อมต่อและนำข้อมูลทั้งหมดออกจากแอปนี้อย่างถาวร",
  youAreAboutToRemoveFromMailingList:
    "คุณกำลังจะลบ {0} ออกจากรายชื่อส่งเมลนี้ บัญชีนี้จะไม่สามารถรับการแจ้งเตือนระดับสต๊อกได้",
  youAreAboutToRemoveMultipleProduct:
    "คุณกำลังจะลบผลิตภัณฑ์ {0} รายการและตัวเลือกออกจากสินค้าคงคลังและตำแหน่งตั้งทั้งหมดของคุณ การดำเนินการนี้ไม่สามารถยกเลิกได้",
  youAreAboutToRemoveProduct:
    "คุณกำลังจะลบผลิตภัณฑ์นี้ออกจากสินค้าคงคลังและที่ตั้งทั้งหมดของคุณ การดำเนินการนี้ไม่สามารถยกเลิกได้",
  youAreAboutToRemoveVariantProduct:
    "คุณกำลังจะลบผลิตภัณฑ์นี้และตัวเลือก {0} รายการออกจากสินค้าคงคลังและตำแหน่งตั้งทั้งหมดของคุณ การดำเนินการนี้ไม่สามารถยกเลิกได้",
  youAreAssigned: "คุณได้รับมอบหมายหน้าที่ดังต่อไปนี้:",
  youAreLoggedInAs: "คุณเข้าสู่ระบบในฐานะ {0}",
  youCanChangeThisLater: "คุณสามารถเปลี่ยนได้ในภายหลัง!",
  youCanNowLogin: "ตอนนี้คุณสามารถเข้าสู่ระบบโดยใช้อีเมลและรหัสผ่านของคุณ",
  youDontHavePermission: "คุณไม่ได้รับอนุญาตให้เข้าถึงลิงก์นี้",
  youHaveUnsavedChanges: "คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึกในหน้านี้",
  youllFindYourBookingsHere: "คุณจะพบการจองของคุณที่นี่",
  yourGeneralSettings: "การตั้งค่าทั่วไปของคุณ เช่น ชื่อสถานที่และสกุลเงิน",
  yourMailingIsEmpty: "รายชื่อผู้รับจดหมายของคุณยังว่างอยู่",
  yourVenues: "สถานที่ของคุณ",
  youveReachedTheEndOfTheList: "คุณมาถึงจุดสิ้นสุดของรายการแล้ว",
  zeroInventory: "สินค้าคงคลังเป็นศูนย์",
  selectCountry: "เลือกประเทศ",
};
export default Object.freeze(locale);
